var map = {
	"./applicationFactory": [
		"0630",
		9,
		"applicationFactory"
	],
	"./applicationFactory.js": [
		"0630",
		9,
		"applicationFactory"
	],
	"./applications/saffronfiles/assets/frameworks/we": [
		"0b52",
		9
	],
	"./applications/saffronfiles/assets/frameworks/we.js": [
		"0b52",
		9
	],
	"./applications/saffronfiles/assets/frameworks/we/_custom.scss": [
		"46c5",
		7,
		"applications-saffronfiles-assets-frameworks-we-_custom-scss"
	],
	"./applications/saffronfiles/assets/frameworks/we/_mixins.scss": [
		"9fe4",
		7,
		"applications-saffronfiles-assets-frameworks-we-_mixins-scss"
	],
	"./applications/saffronfiles/assets/frameworks/we/_variables.scss": [
		"940a",
		7,
		"applications-saffronfiles-assets-frameworks-we-_variables-scss"
	],
	"./applications/saffronfiles/assets/frameworks/we/saffronAdapter": [
		"dc9c",
		9
	],
	"./applications/saffronfiles/assets/frameworks/we/saffronAdapter.js": [
		"dc9c",
		9
	],
	"./applications/saffronfiles/assets/frameworks/we/we": [
		"bbfe",
		9
	],
	"./applications/saffronfiles/assets/frameworks/we/we.js": [
		"bbfe",
		9
	],
	"./applications/saffronfiles/assets/frameworks/we/we.scss": [
		"a661",
		7
	],
	"./applications/saffronfiles/assets/scss/_test.scss": [
		"44fe",
		7,
		"applications-saffronfiles-assets-scss-_test-scss"
	],
	"./applications/saffronfiles/assets/static/core/images/boxy/default-background.webp": [
		"3279",
		7
	],
	"./applications/saffronfiles/assets/static/core/images/index.html": [
		"65a1",
		7
	],
	"./applications/saffronfiles/assets/static/core/images/logos/main.png": [
		"0f5d",
		7
	],
	"./applications/saffronfiles/assets/static/core/images/logos/main.svg": [
		"2aa4",
		7
	],
	"./applications/saffronfiles/assets/static/core/images/user/login/boxy_background_2.jpg": [
		"34b4",
		7
	],
	"./applications/saffronfiles/assets/static/core/images/user/login/boxy_background_3.jpg": [
		"09e6",
		7
	],
	"./applications/saffronfiles/assets/static/core/index.html": [
		"77a1",
		7
	],
	"./applications/saffronfiles/assets/static/images/backgrounds/boxy-default.webp": [
		"66ce",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-2.jpg": [
		"6146",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-3.jpg": [
		"b1b4",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-4.jpg": [
		"6f5f",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-5.jpg": [
		"b13b",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-small.png": [
		"cf15",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg-small.webp": [
		"0539",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg.jpg": [
		"c676",
		7
	],
	"./applications/saffronfiles/assets/static/images/dashboard/backgrounds/dashboard-main-bg.png": [
		"6a06",
		7
	],
	"./applications/saffronfiles/components/App": [
		"6abe",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"applications-saffronfiles-components-App"
	],
	"./applications/saffronfiles/components/App.vue": [
		"6abe",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"applications-saffronfiles-components-App"
	],
	"./applications/saffronfiles/components/Playground": [
		"a366",
		9,
		"applications-saffronfiles-components-Playground"
	],
	"./applications/saffronfiles/components/Playground.vue": [
		"a366",
		9,
		"applications-saffronfiles-components-Playground"
	],
	"./applications/saffronfiles/components/readme.md": [
		"24a6",
		7,
		"applications-saffronfiles-components-readme-md"
	],
	"./applications/saffronfiles/config/modules/locale": [
		"3bfd",
		9
	],
	"./applications/saffronfiles/config/modules/locale.js": [
		"3bfd",
		9
	],
	"./applications/saffronfiles/config/modules/readme.md": [
		"e2bd",
		7,
		"applications-saffronfiles-config-modules-readme-md"
	],
	"./applications/saffronfiles/config/modules/router": [
		"a355",
		9
	],
	"./applications/saffronfiles/config/modules/router.js": [
		"a355",
		9
	],
	"./applications/saffronfiles/config/modules/style": [
		"78b0",
		9
	],
	"./applications/saffronfiles/config/modules/style.js": [
		"78b0",
		9
	],
	"./applications/saffronfiles/config/modules/user": [
		"20bb",
		9
	],
	"./applications/saffronfiles/config/modules/user.js": [
		"20bb",
		9
	],
	"./applications/saffronfiles/config/root": [
		"4f19",
		9
	],
	"./applications/saffronfiles/config/root.js": [
		"4f19",
		9
	],
	"./applications/saffronfiles/extensions/validation/validatorFactories/availableOnRemote": [
		"e9c9",
		9
	],
	"./applications/saffronfiles/extensions/validation/validatorFactories/availableOnRemote.js": [
		"e9c9",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/anyI18nPhoneNumber": [
		"3bed",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/anyI18nPhoneNumber.js": [
		"3bed",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/cleanIsraelyMobilePhoneNumber": [
		"efeb",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/cleanIsraelyMobilePhoneNumber.js": [
		"efeb",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/goodPassword": [
		"bdc3",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/goodPassword.js": [
		"bdc3",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/i18nPhoneNumber": [
		"41f9",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/i18nPhoneNumber.js": [
		"41f9",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/i18nPhoneNumberObject": [
		"4bbf",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/i18nPhoneNumberObject.js": [
		"4bbf",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/israelyPersonalId": [
		"b5fb",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/israelyPersonalId.js": [
		"b5fb",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/readme.md": [
		"a72b",
		7,
		"applications-saffronfiles-extensions-validation-validators-readme-md"
	],
	"./applications/saffronfiles/extensions/validation/validators/urlSafeString": [
		"efa2",
		9
	],
	"./applications/saffronfiles/extensions/validation/validators/urlSafeString.js": [
		"efa2",
		9
	],
	"./applications/saffronfiles/layouts/Default": [
		"0ae7",
		9,
		"applications-saffronfiles-layouts-Default"
	],
	"./applications/saffronfiles/layouts/Default.vue": [
		"0ae7",
		9,
		"applications-saffronfiles-layouts-Default"
	],
	"./applications/saffronfiles/locale/en-US/locale": [
		"8374",
		9
	],
	"./applications/saffronfiles/locale/en-US/locale.js": [
		"8374",
		9
	],
	"./applications/saffronfiles/locale/en-US/messages": [
		"caf3",
		9
	],
	"./applications/saffronfiles/locale/en-US/messages.js": [
		"caf3",
		9
	],
	"./applications/saffronfiles/locale/he-IL/locale": [
		"08df",
		9
	],
	"./applications/saffronfiles/locale/he-IL/locale.js": [
		"08df",
		9
	],
	"./applications/saffronfiles/locale/he-IL/messages": [
		"2732",
		9
	],
	"./applications/saffronfiles/locale/he-IL/messages.js": [
		"2732",
		9
	],
	"./applications/saffronfiles/pages": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./applications/saffronfiles/pages/": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./applications/saffronfiles/pages/index": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./applications/saffronfiles/pages/index.vue": [
		"b1af",
		9,
		"applications-saffronfiles-pages"
	],
	"./applications/saffronfiles/pages/playground": [
		"6d82",
		9,
		"applications-saffronfiles-pages-playground"
	],
	"./applications/saffronfiles/pages/playground.vue": [
		"6d82",
		9,
		"applications-saffronfiles-pages-playground"
	],
	"./applications/saffronfiles/pwaConfig": [
		"ebc3",
		7
	],
	"./applications/saffronfiles/pwaConfig.js": [
		"ebc3",
		7
	],
	"./applications/saffronfiles/router/middleware/redirectsLike404": [
		"50b3",
		9
	],
	"./applications/saffronfiles/router/middleware/redirectsLike404.js": [
		"50b3",
		9
	],
	"./applications/saffronfiles/router/middleware/requireGuest": [
		"c5b6",
		9
	],
	"./applications/saffronfiles/router/middleware/requireGuest.js": [
		"c5b6",
		9
	],
	"./applications/saffronfiles/router/middleware/requireSuperAdmin": [
		"19ff",
		9
	],
	"./applications/saffronfiles/router/middleware/requireSuperAdmin.js": [
		"19ff",
		9
	],
	"./applications/saffronfiles/router/middleware/requireUser": [
		"a669",
		9
	],
	"./applications/saffronfiles/router/middleware/requireUser.js": [
		"a669",
		9
	],
	"./applications/saffronfiles/router/routes/core": [
		"d13b",
		9
	],
	"./applications/saffronfiles/router/routes/core.js": [
		"d13b",
		9
	],
	"./applications/saffronfiles/router/routes/errors": [
		"2258",
		9
	],
	"./applications/saffronfiles/router/routes/errors.js": [
		"2258",
		9
	],
	"./applications/saffronfiles/router/routes/readme.md": [
		"5ff3",
		7,
		"applications-saffronfiles-router-routes-readme-md"
	],
	"./applications/saffronfiles/saffronfiles": [
		"6f07",
		9
	],
	"./applications/saffronfiles/saffronfiles.js": [
		"6f07",
		9
	],
	"./applications/saffronfiles/store/modules/readme.md": [
		"e1c3",
		7,
		"applications-saffronfiles-store-modules-readme-md"
	],
	"./applications/saffronfiles/views/PageNotFound": [
		"55f3",
		9,
		"applications-saffronfiles-views-PageNotFound"
	],
	"./applications/saffronfiles/views/PageNotFound.vue": [
		"55f3",
		9,
		"applications-saffronfiles-views-PageNotFound"
	],
	"./assets": [
		"e2af",
		9,
		"assets"
	],
	"./assets/": [
		"e2af",
		9,
		"assets"
	],
	"./assets/assets": [
		"a64f",
		7,
		"assets-assets"
	],
	"./assets/assets.js": [
		"a64f",
		7,
		"assets-assets"
	],
	"./assets/frameworks": [
		"6804",
		7,
		"assets-frameworks"
	],
	"./assets/frameworks.js": [
		"6804",
		7,
		"assets-frameworks"
	],
	"./assets/frameworks/animate": [
		"be07",
		9,
		"assets-frameworks-animate"
	],
	"./assets/frameworks/animate.js": [
		"be07",
		9,
		"assets-frameworks-animate"
	],
	"./assets/frameworks/animate/animate": [
		"4c9e",
		9,
		"assets-frameworks-animate-animate"
	],
	"./assets/frameworks/animate/animate.js": [
		"4c9e",
		9,
		"assets-frameworks-animate-animate"
	],
	"./assets/frameworks/animate/animate.scss": [
		"9150",
		7,
		"assets-frameworks-animate-animate-scss"
	],
	"./assets/index": [
		"e2af",
		9,
		"assets"
	],
	"./assets/index.js": [
		"e2af",
		9,
		"assets"
	],
	"./assets/scss": [
		"5cc9",
		7,
		"assets-scss"
	],
	"./assets/scss.js": [
		"5cc9",
		7,
		"assets-scss"
	],
	"./assets/scss/styles.scss": [
		"8e16",
		7,
		"assets-scss-styles-scss"
	],
	"./assets/static/core/data/country-code-phone-prefix": [
		"b40e",
		3
	],
	"./assets/static/core/data/country-code-phone-prefix.json": [
		"b40e",
		3
	],
	"./assets/static/core/data/country-list": [
		"d82f",
		3
	],
	"./assets/static/core/data/country-list.json": [
		"d82f",
		3
	],
	"./assets/static/core/images/boxy/default-background.jpg": [
		"7203",
		7
	],
	"./assets/static/core/images/boxy/default-background.webp": [
		"8bed",
		7
	],
	"./assets/static/core/images/boxy/default-background_2.jpg": [
		"4535",
		7
	],
	"./assets/static/core/images/boxy/default-background_2.webp": [
		"9a6e",
		7
	],
	"./assets/static/core/images/index.html": [
		"ce59",
		7
	],
	"./assets/static/core/images/logos/main.png": [
		"103d",
		7
	],
	"./assets/static/core/images/logos/main.svg": [
		"54fc",
		7
	],
	"./assets/static/core/images/sidecut/bg1.jpg": [
		"b50c",
		7
	],
	"./assets/static/core/images/sidecut/bg2.jpg": [
		"6581",
		7
	],
	"./assets/static/core/images/sidecut/bg3.jpg": [
		"2aeb",
		7
	],
	"./assets/static/core/images/user/login/boxy_background.jpg": [
		"a4ea",
		7
	],
	"./assets/static/core/images/user/login/boxy_background_2.jpg": [
		"321e",
		7
	],
	"./assets/static/core/index.html": [
		"db31",
		7
	],
	"./assets/static/core/nav/adminSideNavFactory": [
		"a820",
		9
	],
	"./assets/static/core/nav/adminSideNavFactory.js": [
		"a820",
		9
	],
	"./assets/static/core/nav/userDashboardNavFactory": [
		"a782",
		9
	],
	"./assets/static/core/nav/userDashboardNavFactory.js": [
		"a782",
		9
	],
	"./assets/static/ecommerce/headers/sample_header.jpg": [
		"16a4",
		7
	],
	"./assets/static/ecommerce/headers/sample_header_2.jpg": [
		"e59d",
		7
	],
	"./assets/static/ecommerce/headers/sample_header_3.jpg": [
		"fc6a",
		7
	],
	"./assets/static/icons/rubicons/3d-scan.svg": [
		"2e28",
		7
	],
	"./assets/static/icons/rubicons/airplay.svg": [
		"93e5",
		7
	],
	"./assets/static/icons/rubicons/alarm.svg": [
		"a8bb",
		7
	],
	"./assets/static/icons/rubicons/align-center-alt.svg": [
		"2b27",
		7
	],
	"./assets/static/icons/rubicons/align-center.svg": [
		"4c7b",
		7
	],
	"./assets/static/icons/rubicons/align-justify-alt.svg": [
		"20e9",
		7
	],
	"./assets/static/icons/rubicons/align-justify.svg": [
		"4e83",
		7
	],
	"./assets/static/icons/rubicons/align-left-alt.svg": [
		"7ce1",
		7
	],
	"./assets/static/icons/rubicons/align-left.svg": [
		"7c83",
		7
	],
	"./assets/static/icons/rubicons/align-right-alt.svg": [
		"e346",
		7
	],
	"./assets/static/icons/rubicons/align-right.svg": [
		"e33a",
		7
	],
	"./assets/static/icons/rubicons/archive.svg": [
		"46c4",
		7
	],
	"./assets/static/icons/rubicons/arrow-down-circle.svg": [
		"ef18",
		7
	],
	"./assets/static/icons/rubicons/arrow-down-small.svg": [
		"15c3",
		7
	],
	"./assets/static/icons/rubicons/arrow-down-square.svg": [
		"2e7f",
		7
	],
	"./assets/static/icons/rubicons/arrow-down.svg": [
		"ee74",
		7
	],
	"./assets/static/icons/rubicons/arrow-download-alt.svg": [
		"ec85",
		7
	],
	"./assets/static/icons/rubicons/arrow-download.svg": [
		"50f4",
		7
	],
	"./assets/static/icons/rubicons/arrow-left-circle.svg": [
		"29a0",
		7
	],
	"./assets/static/icons/rubicons/arrow-left-down.svg": [
		"f6fb",
		7
	],
	"./assets/static/icons/rubicons/arrow-left-small.svg": [
		"4f4b",
		7
	],
	"./assets/static/icons/rubicons/arrow-left-square.svg": [
		"9c30",
		7
	],
	"./assets/static/icons/rubicons/arrow-left-up.svg": [
		"eb82",
		7
	],
	"./assets/static/icons/rubicons/arrow-left.svg": [
		"c267",
		7
	],
	"./assets/static/icons/rubicons/arrow-login-left-alt.svg": [
		"ef0a",
		7
	],
	"./assets/static/icons/rubicons/arrow-login-left.svg": [
		"e480",
		7
	],
	"./assets/static/icons/rubicons/arrow-login-right-alt.svg": [
		"b3cb",
		7
	],
	"./assets/static/icons/rubicons/arrow-login-right.svg": [
		"677b",
		7
	],
	"./assets/static/icons/rubicons/arrow-logout-left-alt.svg": [
		"3746",
		7
	],
	"./assets/static/icons/rubicons/arrow-logout-left.svg": [
		"45ce",
		7
	],
	"./assets/static/icons/rubicons/arrow-logout-right-alt.svg": [
		"cce5",
		7
	],
	"./assets/static/icons/rubicons/arrow-logout-right.svg": [
		"6016",
		7
	],
	"./assets/static/icons/rubicons/arrow-right-circle.svg": [
		"09f3",
		7
	],
	"./assets/static/icons/rubicons/arrow-right-down.svg": [
		"44fb",
		7
	],
	"./assets/static/icons/rubicons/arrow-right-small.svg": [
		"af42",
		7
	],
	"./assets/static/icons/rubicons/arrow-right-square.svg": [
		"9fa9",
		7
	],
	"./assets/static/icons/rubicons/arrow-right-up.svg": [
		"f5df",
		7
	],
	"./assets/static/icons/rubicons/arrow-right.svg": [
		"42aa",
		7
	],
	"./assets/static/icons/rubicons/arrow-up-circle.svg": [
		"1a89",
		7
	],
	"./assets/static/icons/rubicons/arrow-up-small.svg": [
		"67a0",
		7
	],
	"./assets/static/icons/rubicons/arrow-up-square.svg": [
		"3325",
		7
	],
	"./assets/static/icons/rubicons/arrow-up.svg": [
		"cdb5",
		7
	],
	"./assets/static/icons/rubicons/arrow-upload-alt.svg": [
		"7ea6",
		7
	],
	"./assets/static/icons/rubicons/arrow-upload.svg": [
		"dec7",
		7
	],
	"./assets/static/icons/rubicons/arrows-sort.svg": [
		"53ba",
		7
	],
	"./assets/static/icons/rubicons/article.svg": [
		"90f3",
		7
	],
	"./assets/static/icons/rubicons/bag-alt.svg": [
		"72fa",
		7
	],
	"./assets/static/icons/rubicons/bag-plus.svg": [
		"11b2",
		7
	],
	"./assets/static/icons/rubicons/bag.svg": [
		"7b4d",
		7
	],
	"./assets/static/icons/rubicons/bar-code.svg": [
		"912b",
		7
	],
	"./assets/static/icons/rubicons/basket.svg": [
		"2707",
		7
	],
	"./assets/static/icons/rubicons/battery-charging.svg": [
		"4398",
		7
	],
	"./assets/static/icons/rubicons/battery-empty.svg": [
		"5eb4",
		7
	],
	"./assets/static/icons/rubicons/battery-full.svg": [
		"4c23",
		7
	],
	"./assets/static/icons/rubicons/battery-half.svg": [
		"76b5",
		7
	],
	"./assets/static/icons/rubicons/bell.svg": [
		"c3ba",
		7
	],
	"./assets/static/icons/rubicons/binder.svg": [
		"0182",
		7
	],
	"./assets/static/icons/rubicons/bluetooth.svg": [
		"36ad",
		7
	],
	"./assets/static/icons/rubicons/book.svg": [
		"48b7",
		7
	],
	"./assets/static/icons/rubicons/bookmark.svg": [
		"40d4",
		7
	],
	"./assets/static/icons/rubicons/brands-codepen.svg": [
		"214da",
		7
	],
	"./assets/static/icons/rubicons/brands-codesandbox.svg": [
		"18eb",
		7
	],
	"./assets/static/icons/rubicons/brands-dribbble.svg": [
		"1735",
		7
	],
	"./assets/static/icons/rubicons/brands-dropbox.svg": [
		"df58",
		7
	],
	"./assets/static/icons/rubicons/brands-facebook.svg": [
		"4a89",
		7
	],
	"./assets/static/icons/rubicons/brands-figma.svg": [
		"f4d7",
		7
	],
	"./assets/static/icons/rubicons/brands-github.svg": [
		"89a9",
		7
	],
	"./assets/static/icons/rubicons/brands-google.svg": [
		"825b",
		7
	],
	"./assets/static/icons/rubicons/brands-instagram.svg": [
		"2379",
		7
	],
	"./assets/static/icons/rubicons/brands-linkedin.svg": [
		"e175",
		7
	],
	"./assets/static/icons/rubicons/brands-paypal.svg": [
		"4097",
		7
	],
	"./assets/static/icons/rubicons/brands-snapchat.svg": [
		"13c5",
		7
	],
	"./assets/static/icons/rubicons/brands-stripe.svg": [
		"0ddd",
		7
	],
	"./assets/static/icons/rubicons/brands-twitter.svg": [
		"ff05",
		7
	],
	"./assets/static/icons/rubicons/brands-youtube.svg": [
		"df7d",
		7
	],
	"./assets/static/icons/rubicons/bug.svg": [
		"b2ea",
		7
	],
	"./assets/static/icons/rubicons/calendar.svg": [
		"d389",
		7
	],
	"./assets/static/icons/rubicons/camera-alt.svg": [
		"9637",
		7
	],
	"./assets/static/icons/rubicons/camera.svg": [
		"5d83",
		7
	],
	"./assets/static/icons/rubicons/cart-basket.svg": [
		"f6a2",
		7
	],
	"./assets/static/icons/rubicons/cart-plus.svg": [
		"eeb7",
		7
	],
	"./assets/static/icons/rubicons/cart.svg": [
		"51354",
		7
	],
	"./assets/static/icons/rubicons/cassette.svg": [
		"0463",
		7
	],
	"./assets/static/icons/rubicons/chart-bar-alt.svg": [
		"5591",
		7
	],
	"./assets/static/icons/rubicons/chart-bar.svg": [
		"7532",
		7
	],
	"./assets/static/icons/rubicons/chart-intersect.svg": [
		"55ee",
		7
	],
	"./assets/static/icons/rubicons/chart-line.svg": [
		"f272",
		7
	],
	"./assets/static/icons/rubicons/chart-pie.svg": [
		"df0d",
		7
	],
	"./assets/static/icons/rubicons/chat-alt.svg": [
		"3ed5",
		7
	],
	"./assets/static/icons/rubicons/chat-incoming-alt.svg": [
		"0ebf",
		7
	],
	"./assets/static/icons/rubicons/chat-incoming.svg": [
		"73c1",
		7
	],
	"./assets/static/icons/rubicons/chat-message-alt.svg": [
		"715d",
		7
	],
	"./assets/static/icons/rubicons/chat-message.svg": [
		"1639",
		7
	],
	"./assets/static/icons/rubicons/chat.svg": [
		"e3d3",
		7
	],
	"./assets/static/icons/rubicons/check-circle.svg": [
		"6f39",
		7
	],
	"./assets/static/icons/rubicons/check-list.svg": [
		"1924",
		7
	],
	"./assets/static/icons/rubicons/check-square.svg": [
		"31d5",
		7
	],
	"./assets/static/icons/rubicons/check.svg": [
		"ee27",
		7
	],
	"./assets/static/icons/rubicons/chevron-down.svg": [
		"b520",
		7
	],
	"./assets/static/icons/rubicons/chevron-left.svg": [
		"6b10",
		7
	],
	"./assets/static/icons/rubicons/chevron-right.svg": [
		"0c3d",
		7
	],
	"./assets/static/icons/rubicons/chevron-up.svg": [
		"9d97",
		7
	],
	"./assets/static/icons/rubicons/chevrons-down.svg": [
		"6878",
		7
	],
	"./assets/static/icons/rubicons/chevrons-left.svg": [
		"32e3",
		7
	],
	"./assets/static/icons/rubicons/chevrons-right.svg": [
		"2ab2",
		7
	],
	"./assets/static/icons/rubicons/chevrons-up.svg": [
		"28ba",
		7
	],
	"./assets/static/icons/rubicons/circle-fill.svg": [
		"d281",
		7
	],
	"./assets/static/icons/rubicons/circle-piece.svg": [
		"e048",
		7
	],
	"./assets/static/icons/rubicons/clipboard-check.svg": [
		"d48a",
		7
	],
	"./assets/static/icons/rubicons/clipboard-x.svg": [
		"3c7b",
		7
	],
	"./assets/static/icons/rubicons/clipboard.svg": [
		"2210",
		7
	],
	"./assets/static/icons/rubicons/clock.svg": [
		"49a5",
		7
	],
	"./assets/static/icons/rubicons/clone-reverse.svg": [
		"3fb6",
		7
	],
	"./assets/static/icons/rubicons/clone.svg": [
		"c787",
		7
	],
	"./assets/static/icons/rubicons/cloud-alt.svg": [
		"1ccc",
		7
	],
	"./assets/static/icons/rubicons/cloud-download.svg": [
		"17e8",
		7
	],
	"./assets/static/icons/rubicons/cloud-rain.svg": [
		"ad7a",
		7
	],
	"./assets/static/icons/rubicons/cloud-upload.svg": [
		"0a85",
		7
	],
	"./assets/static/icons/rubicons/cloud.svg": [
		"cb4d",
		7
	],
	"./assets/static/icons/rubicons/code-arrow-brackets.svg": [
		"272d",
		7
	],
	"./assets/static/icons/rubicons/code.svg": [
		"7fc0",
		7
	],
	"./assets/static/icons/rubicons/collapse.svg": [
		"9b82",
		7
	],
	"./assets/static/icons/rubicons/color-palette.svg": [
		"e50a",
		7
	],
	"./assets/static/icons/rubicons/command.svg": [
		"a5b9",
		7
	],
	"./assets/static/icons/rubicons/contrast.svg": [
		"dbe5",
		7
	],
	"./assets/static/icons/rubicons/copy-alt-reverse.svg": [
		"99b7",
		7
	],
	"./assets/static/icons/rubicons/copy-alt.svg": [
		"e8fd",
		7
	],
	"./assets/static/icons/rubicons/copy-content-reverse.svg": [
		"1d6f",
		7
	],
	"./assets/static/icons/rubicons/copy-content.svg": [
		"e0da",
		7
	],
	"./assets/static/icons/rubicons/copy-page-reverse.svg": [
		"375a",
		7
	],
	"./assets/static/icons/rubicons/copy-page.svg": [
		"325c",
		7
	],
	"./assets/static/icons/rubicons/copy-reverse.svg": [
		"5ee6",
		7
	],
	"./assets/static/icons/rubicons/copy.svg": [
		"d1d2",
		7
	],
	"./assets/static/icons/rubicons/credit-cards.svg": [
		"84f9",
		7
	],
	"./assets/static/icons/rubicons/crop.svg": [
		"a228",
		7
	],
	"./assets/static/icons/rubicons/cube-multi.svg": [
		"caa9",
		7
	],
	"./assets/static/icons/rubicons/cube.svg": [
		"d998",
		7
	],
	"./assets/static/icons/rubicons/dashboard.svg": [
		"9b0c",
		7
	],
	"./assets/static/icons/rubicons/degree.svg": [
		"7472",
		7
	],
	"./assets/static/icons/rubicons/drop.svg": [
		"2377",
		7
	],
	"./assets/static/icons/rubicons/email.svg": [
		"e0d6",
		7
	],
	"./assets/static/icons/rubicons/export.svg": [
		"d5a2",
		7
	],
	"./assets/static/icons/rubicons/eye-alt.svg": [
		"4997",
		7
	],
	"./assets/static/icons/rubicons/eye-hidden.svg": [
		"6223",
		7
	],
	"./assets/static/icons/rubicons/eye.svg": [
		"a947",
		7
	],
	"./assets/static/icons/rubicons/file-copy.svg": [
		"4ab4",
		7
	],
	"./assets/static/icons/rubicons/file-zip.svg": [
		"852b",
		7
	],
	"./assets/static/icons/rubicons/file.svg": [
		"0aa8",
		7
	],
	"./assets/static/icons/rubicons/fire.svg": [
		"0a3a",
		7
	],
	"./assets/static/icons/rubicons/flag.svg": [
		"cb28",
		7
	],
	"./assets/static/icons/rubicons/floppy-disk.svg": [
		"ce45",
		7
	],
	"./assets/static/icons/rubicons/folder-copy.svg": [
		"f9d2",
		7
	],
	"./assets/static/icons/rubicons/folder-minus.svg": [
		"fed5",
		7
	],
	"./assets/static/icons/rubicons/folder-open-alt.svg": [
		"e14a",
		7
	],
	"./assets/static/icons/rubicons/folder-open.svg": [
		"e021",
		7
	],
	"./assets/static/icons/rubicons/folder-plus.svg": [
		"5044",
		7
	],
	"./assets/static/icons/rubicons/folder.svg": [
		"28ec",
		7
	],
	"./assets/static/icons/rubicons/go-back.svg": [
		"dd9f",
		7
	],
	"./assets/static/icons/rubicons/go-forward.svg": [
		"a0d2",
		7
	],
	"./assets/static/icons/rubicons/grid-alt-reverse.svg": [
		"593c",
		7
	],
	"./assets/static/icons/rubicons/grid-alt.svg": [
		"69d9",
		7
	],
	"./assets/static/icons/rubicons/grid-reverse.svg": [
		"ffcc",
		7
	],
	"./assets/static/icons/rubicons/grid.svg": [
		"ed30",
		7
	],
	"./assets/static/icons/rubicons/handle-horizontal.svg": [
		"7756",
		7
	],
	"./assets/static/icons/rubicons/handle-vertical.svg": [
		"6f9a",
		7
	],
	"./assets/static/icons/rubicons/hard-drive.svg": [
		"8e2a",
		7
	],
	"./assets/static/icons/rubicons/hashtag.svg": [
		"42f0",
		7
	],
	"./assets/static/icons/rubicons/headphones.svg": [
		"29df",
		7
	],
	"./assets/static/icons/rubicons/heart.svg": [
		"a303",
		7
	],
	"./assets/static/icons/rubicons/home.svg": [
		"47f7",
		7
	],
	"./assets/static/icons/rubicons/hotspot-alt.svg": [
		"e4ce",
		7
	],
	"./assets/static/icons/rubicons/hotspot.svg": [
		"e28d",
		7
	],
	"./assets/static/icons/rubicons/image.svg": [
		"5636",
		7
	],
	"./assets/static/icons/rubicons/import.svg": [
		"1e55",
		7
	],
	"./assets/static/icons/rubicons/inbox-file.svg": [
		"1dc5",
		7
	],
	"./assets/static/icons/rubicons/inbox.svg": [
		"9e2e",
		7
	],
	"./assets/static/icons/rubicons/info.svg": [
		"2afa",
		7
	],
	"./assets/static/icons/rubicons/iphone.svg": [
		"6fb4",
		7
	],
	"./assets/static/icons/rubicons/keyboard-hide.svg": [
		"7f5f",
		7
	],
	"./assets/static/icons/rubicons/keyboard.svg": [
		"9474",
		7
	],
	"./assets/static/icons/rubicons/language.svg": [
		"34fb",
		7
	],
	"./assets/static/icons/rubicons/laptop.svg": [
		"de1f",
		7
	],
	"./assets/static/icons/rubicons/layer-stack.svg": [
		"bfaa",
		7
	],
	"./assets/static/icons/rubicons/life-float.svg": [
		"1cb6",
		7
	],
	"./assets/static/icons/rubicons/lightbulb.svg": [
		"421c",
		7
	],
	"./assets/static/icons/rubicons/link-alt.svg": [
		"6840",
		7
	],
	"./assets/static/icons/rubicons/link.svg": [
		"363c",
		7
	],
	"./assets/static/icons/rubicons/location.svg": [
		"2f9e",
		7
	],
	"./assets/static/icons/rubicons/lock-alt.svg": [
		"067b",
		7
	],
	"./assets/static/icons/rubicons/lock.svg": [
		"a386",
		7
	],
	"./assets/static/icons/rubicons/magnify-minus.svg": [
		"fe48",
		7
	],
	"./assets/static/icons/rubicons/magnify-plus.svg": [
		"e02d",
		7
	],
	"./assets/static/icons/rubicons/magnify.svg": [
		"e48f",
		7
	],
	"./assets/static/icons/rubicons/mail-alt.svg": [
		"c871",
		7
	],
	"./assets/static/icons/rubicons/mail.svg": [
		"225d",
		7
	],
	"./assets/static/icons/rubicons/map-pin-location-alt.svg": [
		"a6da",
		7
	],
	"./assets/static/icons/rubicons/map-pin-location.svg": [
		"9fcb",
		7
	],
	"./assets/static/icons/rubicons/map-pin.svg": [
		"ce65",
		7
	],
	"./assets/static/icons/rubicons/map.svg": [
		"af92",
		7
	],
	"./assets/static/icons/rubicons/maximize.svg": [
		"217b",
		7
	],
	"./assets/static/icons/rubicons/mc-fast-forward.svg": [
		"3cd1",
		7
	],
	"./assets/static/icons/rubicons/mc-pause.svg": [
		"0ee6",
		7
	],
	"./assets/static/icons/rubicons/mc-play.svg": [
		"7830",
		7
	],
	"./assets/static/icons/rubicons/mc-repeat-all.svg": [
		"b776",
		7
	],
	"./assets/static/icons/rubicons/mc-repeat-one.svg": [
		"ba36",
		7
	],
	"./assets/static/icons/rubicons/mc-repeat.svg": [
		"79f1",
		7
	],
	"./assets/static/icons/rubicons/mc-shuffle.svg": [
		"4b99",
		7
	],
	"./assets/static/icons/rubicons/mc-skip-back.svg": [
		"29ff",
		7
	],
	"./assets/static/icons/rubicons/mc-skip.svg": [
		"1219",
		7
	],
	"./assets/static/icons/rubicons/mc-volume-off.svg": [
		"21b0",
		7
	],
	"./assets/static/icons/rubicons/mc-volume.svg": [
		"f4e2",
		7
	],
	"./assets/static/icons/rubicons/menu-grid.svg": [
		"ec6a",
		7
	],
	"./assets/static/icons/rubicons/mic-off.svg": [
		"efca",
		7
	],
	"./assets/static/icons/rubicons/mic.svg": [
		"1c6a",
		7
	],
	"./assets/static/icons/rubicons/minimize.svg": [
		"5c33",
		7
	],
	"./assets/static/icons/rubicons/minus-circle.svg": [
		"c741",
		7
	],
	"./assets/static/icons/rubicons/minus-square.svg": [
		"040e",
		7
	],
	"./assets/static/icons/rubicons/minus.svg": [
		"b16a",
		7
	],
	"./assets/static/icons/rubicons/monitor.svg": [
		"e1a0",
		7
	],
	"./assets/static/icons/rubicons/moon.svg": [
		"4136",
		7
	],
	"./assets/static/icons/rubicons/mouse.svg": [
		"173a",
		7
	],
	"./assets/static/icons/rubicons/move.svg": [
		"e165",
		7
	],
	"./assets/static/icons/rubicons/paperclip-alt.svg": [
		"b210",
		7
	],
	"./assets/static/icons/rubicons/paperclip.svg": [
		"337e",
		7
	],
	"./assets/static/icons/rubicons/paragraph.svg": [
		"6a068",
		7
	],
	"./assets/static/icons/rubicons/pen-tool.svg": [
		"e4d9",
		7
	],
	"./assets/static/icons/rubicons/pen.svg": [
		"e387",
		7
	],
	"./assets/static/icons/rubicons/pencil-draw.svg": [
		"1d5a",
		7
	],
	"./assets/static/icons/rubicons/pencil-write.svg": [
		"d5d0",
		7
	],
	"./assets/static/icons/rubicons/pencil.svg": [
		"2bbd",
		7
	],
	"./assets/static/icons/rubicons/percent.svg": [
		"5a1a",
		7
	],
	"./assets/static/icons/rubicons/phone-hangup.svg": [
		"8689",
		7
	],
	"./assets/static/icons/rubicons/phone-receiving.svg": [
		"e9bc",
		7
	],
	"./assets/static/icons/rubicons/phone-ringing.svg": [
		"c7f2",
		7
	],
	"./assets/static/icons/rubicons/plus-circle.svg": [
		"6dac",
		7
	],
	"./assets/static/icons/rubicons/plus-square.svg": [
		"822a",
		7
	],
	"./assets/static/icons/rubicons/plus.svg": [
		"447d",
		7
	],
	"./assets/static/icons/rubicons/print.svg": [
		"aea5",
		7
	],
	"./assets/static/icons/rubicons/qr-code.svg": [
		"5c74",
		7
	],
	"./assets/static/icons/rubicons/question.svg": [
		"44dd",
		7
	],
	"./assets/static/icons/rubicons/redo-alt.svg": [
		"1f20",
		7
	],
	"./assets/static/icons/rubicons/redo.svg": [
		"85e2",
		7
	],
	"./assets/static/icons/rubicons/refresh.svg": [
		"225f",
		7
	],
	"./assets/static/icons/rubicons/resize-alt-reverse.svg": [
		"9bdb",
		7
	],
	"./assets/static/icons/rubicons/resize-alt.svg": [
		"b543",
		7
	],
	"./assets/static/icons/rubicons/resize-reverse.svg": [
		"4d57e",
		7
	],
	"./assets/static/icons/rubicons/resize.svg": [
		"9f67",
		7
	],
	"./assets/static/icons/rubicons/rss.svg": [
		"fea6",
		7
	],
	"./assets/static/icons/rubicons/scan.svg": [
		"1445",
		7
	],
	"./assets/static/icons/rubicons/send-alt.svg": [
		"1841",
		7
	],
	"./assets/static/icons/rubicons/send.svg": [
		"fbd7",
		7
	],
	"./assets/static/icons/rubicons/server-alt.svg": [
		"4a75",
		7
	],
	"./assets/static/icons/rubicons/server-cloud.svg": [
		"48c9",
		7
	],
	"./assets/static/icons/rubicons/server.svg": [
		"150d",
		7
	],
	"./assets/static/icons/rubicons/settings.svg": [
		"7f53",
		7
	],
	"./assets/static/icons/rubicons/shape-circle.svg": [
		"c522",
		7
	],
	"./assets/static/icons/rubicons/shape-square.svg": [
		"4ce2",
		7
	],
	"./assets/static/icons/rubicons/shape-triangle.svg": [
		"86a8",
		7
	],
	"./assets/static/icons/rubicons/shapes.svg": [
		"eb04",
		7
	],
	"./assets/static/icons/rubicons/share.svg": [
		"eeeb",
		7
	],
	"./assets/static/icons/rubicons/shield-check.svg": [
		"8887",
		7
	],
	"./assets/static/icons/rubicons/shield-hidden.svg": [
		"bdda",
		7
	],
	"./assets/static/icons/rubicons/shield-x.svg": [
		"0640",
		7
	],
	"./assets/static/icons/rubicons/shield.svg": [
		"c7ed",
		7
	],
	"./assets/static/icons/rubicons/sliders-alt-horizontal.svg": [
		"4780",
		7
	],
	"./assets/static/icons/rubicons/sliders-alt-vertical.svg": [
		"ba9d",
		7
	],
	"./assets/static/icons/rubicons/sliders-horizontal.svg": [
		"a00e",
		7
	],
	"./assets/static/icons/rubicons/sliders-vertical.svg": [
		"d8c4",
		7
	],
	"./assets/static/icons/rubicons/social-facebook.svg": [
		"c6b9",
		7
	],
	"./assets/static/icons/rubicons/speaker.svg": [
		"d3fa",
		7
	],
	"./assets/static/icons/rubicons/star-fill.svg": [
		"47bd",
		7
	],
	"./assets/static/icons/rubicons/star.svg": [
		"9d2f",
		7
	],
	"./assets/static/icons/rubicons/stopwatch.svg": [
		"2cc3",
		7
	],
	"./assets/static/icons/rubicons/sun.svg": [
		"3edc",
		7
	],
	"./assets/static/icons/rubicons/terminal-alt.svg": [
		"de6a",
		7
	],
	"./assets/static/icons/rubicons/terminal.svg": [
		"2f26",
		7
	],
	"./assets/static/icons/rubicons/thumbs-down.svg": [
		"6111",
		7
	],
	"./assets/static/icons/rubicons/thumbs-up.svg": [
		"be22",
		7
	],
	"./assets/static/icons/rubicons/trash-alt.svg": [
		"6faa",
		7
	],
	"./assets/static/icons/rubicons/trash.svg": [
		"a344",
		7
	],
	"./assets/static/icons/rubicons/undo-alt.svg": [
		"2999",
		7
	],
	"./assets/static/icons/rubicons/undo.svg": [
		"63a0",
		7
	],
	"./assets/static/icons/rubicons/unlock-alt.svg": [
		"ceee",
		7
	],
	"./assets/static/icons/rubicons/unlock.svg": [
		"4135",
		7
	],
	"./assets/static/icons/rubicons/user-minus-alt.svg": [
		"a866",
		7
	],
	"./assets/static/icons/rubicons/user-minus.svg": [
		"5668",
		7
	],
	"./assets/static/icons/rubicons/user-plus-alt.svg": [
		"e663",
		7
	],
	"./assets/static/icons/rubicons/user-plus.svg": [
		"02db",
		7
	],
	"./assets/static/icons/rubicons/user.svg": [
		"20f8",
		7
	],
	"./assets/static/icons/rubicons/users.svg": [
		"6984",
		7
	],
	"./assets/static/icons/rubicons/video-off.svg": [
		"8822",
		7
	],
	"./assets/static/icons/rubicons/video.svg": [
		"24ad",
		7
	],
	"./assets/static/icons/rubicons/voicemail.svg": [
		"fb5b",
		7
	],
	"./assets/static/icons/rubicons/wallet.svg": [
		"56f0",
		7
	],
	"./assets/static/icons/rubicons/warning-circle.svg": [
		"8c8f",
		7
	],
	"./assets/static/icons/rubicons/warning-triangle.svg": [
		"ad3f",
		7
	],
	"./assets/static/icons/rubicons/watch.svg": [
		"9245",
		7
	],
	"./assets/static/icons/rubicons/wifi-disabled.svg": [
		"77ff",
		7
	],
	"./assets/static/icons/rubicons/wifi.svg": [
		"658f",
		7
	],
	"./assets/static/icons/rubicons/x-circle.svg": [
		"4a3b",
		7
	],
	"./assets/static/icons/rubicons/x-square.svg": [
		"22a2",
		7
	],
	"./assets/static/icons/rubicons/x.svg": [
		"e81c",
		7
	],
	"./assets/static/images/logos/main.png": [
		"a988",
		7
	],
	"./assets/static/images/logos/main.svg": [
		"3cdd",
		7
	],
	"./assets/static/images/logos/main_alt.svg": [
		"a883",
		7
	],
	"./assets/static/images/logos/main_vf.svg": [
		"c6dc",
		7
	],
	"./assets/static/images/logos/saffron.png": [
		"7ea2",
		7
	],
	"./assets/static/images/logos/saffron.svg": [
		"a0b4",
		7
	],
	"./assets/static/images/selfcare/flags/france.svg": [
		"7174",
		7
	],
	"./assets/static/images/selfcare/flags/germany.svg": [
		"c220",
		7
	],
	"./assets/static/images/selfcare/flags/united-kingdom.svg": [
		"33fa",
		7
	],
	"./assets/static/images/selfcare/sample-banner-2.jpg": [
		"1780",
		7
	],
	"./assets/static/images/selfcare/sample-banner.png": [
		"935c",
		7
	],
	"./assets/static/images/selfcare/temp-bg.jpg": [
		"64c7",
		7
	],
	"./assets/static/logos/main.png": [
		"271b",
		7
	],
	"./assets/static/logos/main.svg": [
		"a1ae",
		7
	],
	"./assets/static/logos/main_alt.svg": [
		"d61a",
		7
	],
	"./assets/static/logos/main_vf.svg": [
		"90fd",
		7
	],
	"./assets/static/scss/styles.scss": [
		"0047",
		7
	],
	"./components/Saffron": [
		"101d",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-Saffron"
	],
	"./components/Saffron.vue": [
		"101d",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-Saffron"
	],
	"./components/admin/UseCaseAclTree": [
		"c8f2",
		9,
		"components-admin-UseCaseAclTree"
	],
	"./components/admin/UseCaseAclTree.vue": [
		"c8f2",
		9,
		"components-admin-UseCaseAclTree"
	],
	"./components/base/frameworks/tailwind/trailwindComponent": [
		"6f43",
		9,
		"components-base-frameworks-tailwind-trailwindComponent"
	],
	"./components/base/frameworks/tailwind/trailwindComponent.vue": [
		"6f43",
		9,
		"components-base-frameworks-tailwind-trailwindComponent"
	],
	"./components/base/frameworks/we/Alert": [
		"2174",
		9,
		"components-base-frameworks-we-Alert"
	],
	"./components/base/frameworks/we/Alert.vue": [
		"2174",
		9,
		"components-base-frameworks-we-Alert"
	],
	"./components/base/frameworks/we/Breadcrumbs": [
		"c624",
		9,
		"components-base-frameworks-we-Breadcrumbs"
	],
	"./components/base/frameworks/we/Breadcrumbs.vue": [
		"c624",
		9,
		"components-base-frameworks-we-Breadcrumbs"
	],
	"./components/base/frameworks/we/ConnectionQualityIndicator": [
		"f684",
		9,
		"components-base-frameworks-we-ConnectionQualityIndicator"
	],
	"./components/base/frameworks/we/ConnectionQualityIndicator.vue": [
		"f684",
		9,
		"components-base-frameworks-we-ConnectionQualityIndicator"
	],
	"./components/base/frameworks/we/FloatingWidget": [
		"6380",
		9,
		"components-base-frameworks-we-FloatingWidget"
	],
	"./components/base/frameworks/we/FloatingWidget.vue": [
		"6380",
		9,
		"components-base-frameworks-we-FloatingWidget"
	],
	"./components/base/frameworks/we/MediaManager": [
		"09a6",
		9,
		"components-base-frameworks-we-MediaManager"
	],
	"./components/base/frameworks/we/MediaManager.vue": [
		"09a6",
		9,
		"components-base-frameworks-we-MediaManager"
	],
	"./components/base/frameworks/we/Modal": [
		"c412",
		9,
		"components-base-frameworks-we-Modal"
	],
	"./components/base/frameworks/we/Modal.vue": [
		"c412",
		9,
		"components-base-frameworks-we-Modal"
	],
	"./components/base/frameworks/we/Notification": [
		"003b",
		9,
		"components-base-frameworks-we-Notification"
	],
	"./components/base/frameworks/we/Notification.vue": [
		"003b",
		9,
		"components-base-frameworks-we-Notification"
	],
	"./components/base/frameworks/we/Pagination": [
		"c52a",
		9,
		"components-base-frameworks-we-Pagination"
	],
	"./components/base/frameworks/we/Pagination.vue": [
		"c52a",
		9,
		"components-base-frameworks-we-Pagination"
	],
	"./components/base/frameworks/we/PillNav": [
		"697a",
		9,
		"components-base-frameworks-we-PillNav"
	],
	"./components/base/frameworks/we/PillNav.vue": [
		"697a",
		9,
		"components-base-frameworks-we-PillNav"
	],
	"./components/base/frameworks/we/SaffronLink": [
		"9d1c",
		9,
		"components-base-frameworks-we-SaffronLink"
	],
	"./components/base/frameworks/we/SaffronLink.vue": [
		"9d1c",
		9,
		"components-base-frameworks-we-SaffronLink"
	],
	"./components/base/frameworks/we/Skeleton": [
		"286f",
		9,
		"components-base-frameworks-we-Skeleton"
	],
	"./components/base/frameworks/we/Skeleton.vue": [
		"286f",
		9,
		"components-base-frameworks-we-Skeleton"
	],
	"./components/base/frameworks/we/Tabs": [
		"d215",
		9,
		"components-base-frameworks-we-Tabs"
	],
	"./components/base/frameworks/we/Tabs.vue": [
		"d215",
		9,
		"components-base-frameworks-we-Tabs"
	],
	"./components/base/frameworks/we/etc/Badge": [
		"0d00",
		9,
		"components-base-frameworks-we-etc-Badge"
	],
	"./components/base/frameworks/we/etc/Badge.vue": [
		"0d00",
		9,
		"components-base-frameworks-we-etc-Badge"
	],
	"./components/base/frameworks/we/etc/Card": [
		"4b77",
		9,
		"components-base-frameworks-we-etc-Card"
	],
	"./components/base/frameworks/we/etc/Card.vue": [
		"4b77",
		9,
		"components-base-frameworks-we-etc-Card"
	],
	"./components/base/frameworks/we/etc/Debug": [
		"da01",
		9,
		"components-base-frameworks-we-etc-Debug"
	],
	"./components/base/frameworks/we/etc/Debug.vue": [
		"da01",
		9,
		"components-base-frameworks-we-etc-Debug"
	],
	"./components/base/frameworks/we/etc/Drawer": [
		"92e6",
		9,
		"components-base-frameworks-we-etc-Drawer"
	],
	"./components/base/frameworks/we/etc/Drawer.vue": [
		"92e6",
		9,
		"components-base-frameworks-we-etc-Drawer"
	],
	"./components/base/frameworks/we/etc/InactivityDisconnect": [
		"dee0",
		9,
		"components-base-frameworks-we-etc-InactivityDisconnect"
	],
	"./components/base/frameworks/we/etc/InactivityDisconnect.vue": [
		"dee0",
		9,
		"components-base-frameworks-we-etc-InactivityDisconnect"
	],
	"./components/base/frameworks/we/etc/LanguageSwitcher": [
		"c40f",
		9,
		"components-base-frameworks-we-etc-LanguageSwitcher"
	],
	"./components/base/frameworks/we/etc/LanguageSwitcher.vue": [
		"c40f",
		9,
		"components-base-frameworks-we-etc-LanguageSwitcher"
	],
	"./components/base/frameworks/we/etc/Legal": [
		"2663",
		9,
		"components-base-frameworks-we-etc-Legal"
	],
	"./components/base/frameworks/we/etc/Legal.vue": [
		"2663",
		9,
		"components-base-frameworks-we-etc-Legal"
	],
	"./components/base/frameworks/we/etc/Panel": [
		"6d9e",
		9,
		"components-base-frameworks-we-etc-Panel"
	],
	"./components/base/frameworks/we/etc/Panel.vue": [
		"6d9e",
		9,
		"components-base-frameworks-we-etc-Panel"
	],
	"./components/base/frameworks/we/etc/SimpleValueList": [
		"1bbc",
		9,
		"components-base-frameworks-we-etc-SimpleValueList"
	],
	"./components/base/frameworks/we/etc/SimpleValueList.vue": [
		"1bbc",
		9,
		"components-base-frameworks-we-etc-SimpleValueList"
	],
	"./components/base/frameworks/we/etc/SiteCredits": [
		"91be",
		9,
		"components-base-frameworks-we-etc-SiteCredits"
	],
	"./components/base/frameworks/we/etc/SiteCredits.vue": [
		"91be",
		9,
		"components-base-frameworks-we-etc-SiteCredits"
	],
	"./components/base/frameworks/we/etc/SocialShare": [
		"6250",
		9,
		"components-base-frameworks-we-etc-SocialShare"
	],
	"./components/base/frameworks/we/etc/SocialShare.vue": [
		"6250",
		9,
		"components-base-frameworks-we-etc-SocialShare"
	],
	"./components/base/frameworks/we/etc/YoutubeVideoWithModal": [
		"8041",
		9,
		"components-base-frameworks-we-etc-YoutubeVideoWithModal"
	],
	"./components/base/frameworks/we/etc/YoutubeVideoWithModal.vue": [
		"8041",
		9,
		"components-base-frameworks-we-etc-YoutubeVideoWithModal"
	],
	"./components/base/frameworks/we/form/BaseForm": [
		"77a6",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"components-base-frameworks-we-form-BaseForm"
	],
	"./components/base/frameworks/we/form/BaseForm.vue": [
		"77a6",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"components-base-frameworks-we-form-BaseForm"
	],
	"./components/base/frameworks/we/form/CollapsableFieldSet": [
		"61c9",
		9,
		"components-base-frameworks-we-form-CollapsableFieldSet"
	],
	"./components/base/frameworks/we/form/CollapsableFieldSet.vue": [
		"61c9",
		9,
		"components-base-frameworks-we-form-CollapsableFieldSet"
	],
	"./components/base/frameworks/we/form/FormButton": [
		"39ec",
		9,
		"components-base-frameworks-we-form-FormButton"
	],
	"./components/base/frameworks/we/form/FormButton.vue": [
		"39ec",
		9,
		"components-base-frameworks-we-form-FormButton"
	],
	"./components/base/frameworks/we/form/FormFieldSet": [
		"e54a",
		9,
		"components-base-frameworks-we-form-FormFieldSet"
	],
	"./components/base/frameworks/we/form/FormFieldSet.vue": [
		"e54a",
		9,
		"components-base-frameworks-we-form-FormFieldSet"
	],
	"./components/base/frameworks/we/form/controls/FormInput": [
		"52e8",
		9,
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"components-base-frameworks-we-form-controls-FormInput"
	],
	"./components/base/frameworks/we/form/controls/FormInput.vue": [
		"52e8",
		9,
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"components-base-frameworks-we-form-controls-FormInput"
	],
	"./components/base/frameworks/we/form/controls/FreeLabel": [
		"0d69",
		9,
		"components-base-frameworks-we-form-controls-FreeLabel"
	],
	"./components/base/frameworks/we/form/controls/FreeLabel.vue": [
		"0d69",
		9,
		"components-base-frameworks-we-form-controls-FreeLabel"
	],
	"./components/base/frameworks/we/form/controls/inputs/ColorInput": [
		"b179",
		9,
		"components-base-frameworks-we-form-controls-inputs-ColorInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/ColorInput.vue": [
		"b179",
		9,
		"components-base-frameworks-we-form-controls-inputs-ColorInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/CountryListInput": [
		"3919",
		9,
		"components-base-frameworks-we-form-controls-inputs-CountryListInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/CountryListInput.vue": [
		"3919",
		9,
		"components-base-frameworks-we-form-controls-inputs-CountryListInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/CurrencyInput": [
		"1733",
		9,
		"components-base-frameworks-we-form-controls-inputs-CurrencyInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/CurrencyInput.vue": [
		"1733",
		9,
		"components-base-frameworks-we-form-controls-inputs-CurrencyInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/DateInput": [
		"3d95",
		9,
		"components-base-frameworks-we-form-controls-inputs-DateInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/DateInput.vue": [
		"3d95",
		9,
		"components-base-frameworks-we-form-controls-inputs-DateInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/DatePickerInput": [
		"ee56",
		9,
		"components-base-frameworks-we-form-controls-inputs-DatePickerInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/DatePickerInput.vue": [
		"ee56",
		9,
		"components-base-frameworks-we-form-controls-inputs-DatePickerInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/EditorInput": [
		"127f",
		9,
		"components-base-frameworks-we-form-controls-inputs-EditorInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/EditorInput.vue": [
		"127f",
		9,
		"components-base-frameworks-we-form-controls-inputs-EditorInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/FileInput": [
		"c715",
		9,
		"components-base-frameworks-we-form-controls-inputs-FileInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/FileInput.vue": [
		"c715",
		9,
		"components-base-frameworks-we-form-controls-inputs-FileInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/I18nPhoneNumberInput": [
		"22f8",
		9,
		"components-base-frameworks-we-form-controls-inputs-I18nPhoneNumberInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/I18nPhoneNumberInput.vue": [
		"22f8",
		9,
		"components-base-frameworks-we-form-controls-inputs-I18nPhoneNumberInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/LargeOptionsInput": [
		"c5b9",
		9,
		"components-base-frameworks-we-form-controls-inputs-LargeOptionsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/LargeOptionsInput.vue": [
		"c5b9",
		9,
		"components-base-frameworks-we-form-controls-inputs-LargeOptionsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/LocaleInput": [
		"7e8f",
		9,
		"components-base-frameworks-we-form-controls-inputs-LocaleInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/LocaleInput.vue": [
		"7e8f",
		9,
		"components-base-frameworks-we-form-controls-inputs-LocaleInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/MappedSelect2Input": [
		"72a6",
		9,
		"components-base-frameworks-we-form-controls-inputs-MappedSelect2Input"
	],
	"./components/base/frameworks/we/form/controls/inputs/MappedSelect2Input.vue": [
		"72a6",
		9,
		"components-base-frameworks-we-form-controls-inputs-MappedSelect2Input"
	],
	"./components/base/frameworks/we/form/controls/inputs/MediaUrlInput": [
		"bff0",
		9,
		"components-base-frameworks-we-form-controls-inputs-MediaUrlInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/MediaUrlInput.vue": [
		"bff0",
		9,
		"components-base-frameworks-we-form-controls-inputs-MediaUrlInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/PasswordInput": [
		"0468",
		9,
		"components-base-frameworks-we-form-controls-inputs-PasswordInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/PasswordInput.vue": [
		"0468",
		9,
		"components-base-frameworks-we-form-controls-inputs-PasswordInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/PriceInput": [
		"7d60",
		9,
		"components-base-frameworks-we-form-controls-inputs-PriceInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/PriceInput.vue": [
		"7d60",
		9,
		"components-base-frameworks-we-form-controls-inputs-PriceInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/RangeInput": [
		"ef26",
		9,
		"components-base-frameworks-we-form-controls-inputs-RangeInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/RangeInput.vue": [
		"ef26",
		9,
		"components-base-frameworks-we-form-controls-inputs-RangeInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/RepeatableInput": [
		"a2fa",
		9,
		"components-base-frameworks-we-form-controls-inputs-RepeatableInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/RepeatableInput.vue": [
		"a2fa",
		9,
		"components-base-frameworks-we-form-controls-inputs-RepeatableInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/Select2Input": [
		"5b0b",
		9,
		"components-base-frameworks-we-form-controls-inputs-Select2Input"
	],
	"./components/base/frameworks/we/form/controls/inputs/Select2Input.vue": [
		"5b0b",
		9,
		"components-base-frameworks-we-form-controls-inputs-Select2Input"
	],
	"./components/base/frameworks/we/form/controls/inputs/SelectInput": [
		"23e4",
		9,
		"components-base-frameworks-we-form-controls-inputs-SelectInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/SelectInput.vue": [
		"23e4",
		9,
		"components-base-frameworks-we-form-controls-inputs-SelectInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/SelectMediaInput": [
		"969f",
		9,
		"components-base-frameworks-we-form-controls-inputs-SelectMediaInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/SelectMediaInput.vue": [
		"969f",
		9,
		"components-base-frameworks-we-form-controls-inputs-SelectMediaInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/SimpleInput": [
		"cd84",
		9,
		"components-base-frameworks-we-form-controls-inputs-SimpleInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/SimpleInput.vue": [
		"cd84",
		9,
		"components-base-frameworks-we-form-controls-inputs-SimpleInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/StarRatingInput": [
		"041b",
		9,
		"components-base-frameworks-we-form-controls-inputs-StarRatingInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/StarRatingInput.vue": [
		"041b",
		9,
		"components-base-frameworks-we-form-controls-inputs-StarRatingInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/TextAreaInput": [
		"43dc",
		9,
		"components-base-frameworks-we-form-controls-inputs-TextAreaInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/TextAreaInput.vue": [
		"43dc",
		9,
		"components-base-frameworks-we-form-controls-inputs-TextAreaInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/ToggleInput": [
		"8b5a",
		9,
		"components-base-frameworks-we-form-controls-inputs-ToggleInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/ToggleInput.vue": [
		"8b5a",
		9,
		"components-base-frameworks-we-form-controls-inputs-ToggleInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/TranslationsInput": [
		"9a5c",
		9,
		"components-base-frameworks-we-form-controls-inputs-TranslationsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/TranslationsInput.vue": [
		"9a5c",
		9,
		"components-base-frameworks-we-form-controls-inputs-TranslationsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/UnitsInput": [
		"aa8f",
		9,
		"components-base-frameworks-we-form-controls-inputs-UnitsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/UnitsInput.vue": [
		"aa8f",
		9,
		"components-base-frameworks-we-form-controls-inputs-UnitsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/WeThemeSettingsInput": [
		"b83d",
		9,
		"components-base-frameworks-we-form-controls-inputs-WeThemeSettingsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/WeThemeSettingsInput.vue": [
		"b83d",
		9,
		"components-base-frameworks-we-form-controls-inputs-WeThemeSettingsInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/YoutubeVideoIdInput": [
		"9270",
		9,
		"components-base-frameworks-we-form-controls-inputs-YoutubeVideoIdInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/YoutubeVideoIdInput.vue": [
		"9270",
		9,
		"components-base-frameworks-we-form-controls-inputs-YoutubeVideoIdInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/largeOptions/LargeOption": [
		"e6e0",
		9,
		"components-base-frameworks-we-form-controls-inputs-largeOptions-LargeOption"
	],
	"./components/base/frameworks/we/form/controls/inputs/largeOptions/LargeOption.vue": [
		"e6e0",
		9,
		"components-base-frameworks-we-form-controls-inputs-largeOptions-LargeOption"
	],
	"./components/base/frameworks/we/form/controls/inputs/largeOptions/LargeOptionAddOn": [
		"860b",
		9,
		"components-base-frameworks-we-form-controls-inputs-largeOptions-LargeOptionAddOn"
	],
	"./components/base/frameworks/we/form/controls/inputs/largeOptions/LargeOptionAddOn.vue": [
		"860b",
		9,
		"components-base-frameworks-we-form-controls-inputs-largeOptions-LargeOptionAddOn"
	],
	"./components/base/frameworks/we/form/controls/inputs/select2/QuickMediaInput": [
		"5950",
		9,
		"components-base-frameworks-we-form-controls-inputs-select2-QuickMediaInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/select2/QuickMediaInput.vue": [
		"5950",
		9,
		"components-base-frameworks-we-form-controls-inputs-select2-QuickMediaInput"
	],
	"./components/base/frameworks/we/form/controls/inputs/select2/iconItem": [
		"e01d",
		9,
		"components-base-frameworks-we-form-controls-inputs-select2-iconItem"
	],
	"./components/base/frameworks/we/form/controls/inputs/select2/iconItem.vue": [
		"e01d",
		9,
		"components-base-frameworks-we-form-controls-inputs-select2-iconItem"
	],
	"./components/base/frameworks/we/html/Anchor": [
		"310e",
		9,
		"components-base-frameworks-we-html-Anchor"
	],
	"./components/base/frameworks/we/html/Anchor.vue": [
		"310e",
		9,
		"components-base-frameworks-we-html-Anchor"
	],
	"./components/base/frameworks/we/html/Block": [
		"b5f5",
		9,
		"components-base-frameworks-we-html-Block"
	],
	"./components/base/frameworks/we/html/Block.vue": [
		"b5f5",
		9,
		"components-base-frameworks-we-html-Block"
	],
	"./components/base/frameworks/we/html/ButtonGroup": [
		"c679",
		9,
		"components-base-frameworks-we-html-ButtonGroup"
	],
	"./components/base/frameworks/we/html/ButtonGroup.vue": [
		"c679",
		9,
		"components-base-frameworks-we-html-ButtonGroup"
	],
	"./components/base/frameworks/we/html/CleanWrapper": [
		"b86dd",
		9,
		"components-base-frameworks-we-html-CleanWrapper"
	],
	"./components/base/frameworks/we/html/CleanWrapper.vue": [
		"b86dd",
		9,
		"components-base-frameworks-we-html-CleanWrapper"
	],
	"./components/base/frameworks/we/html/ContentBlocks": [
		"b966",
		9,
		"components-base-frameworks-we-html-ContentBlocks"
	],
	"./components/base/frameworks/we/html/ContentBlocks.vue": [
		"b966",
		9,
		"components-base-frameworks-we-html-ContentBlocks"
	],
	"./components/base/frameworks/we/html/ContentBlocks/HeaderBlock": [
		"2771",
		9,
		"components-base-frameworks-we-html-ContentBlocks-HeaderBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/HeaderBlock.vue": [
		"2771",
		9,
		"components-base-frameworks-we-html-ContentBlocks-HeaderBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/ListBlock": [
		"b998",
		9,
		"components-base-frameworks-we-html-ContentBlocks-ListBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/ListBlock.vue": [
		"b998",
		9,
		"components-base-frameworks-we-html-ContentBlocks-ListBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/ParagraphBlock": [
		"509e",
		9,
		"components-base-frameworks-we-html-ContentBlocks-ParagraphBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/ParagraphBlock.vue": [
		"509e",
		9,
		"components-base-frameworks-we-html-ContentBlocks-ParagraphBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/UnknownBlock": [
		"6115",
		9,
		"components-base-frameworks-we-html-ContentBlocks-UnknownBlock"
	],
	"./components/base/frameworks/we/html/ContentBlocks/UnknownBlock.vue": [
		"6115",
		9,
		"components-base-frameworks-we-html-ContentBlocks-UnknownBlock"
	],
	"./components/base/frameworks/we/html/Icon": [
		"5808",
		9,
		"components-base-frameworks-we-html-Icon"
	],
	"./components/base/frameworks/we/html/Icon.vue": [
		"5808",
		9,
		"components-base-frameworks-we-html-Icon"
	],
	"./components/base/frameworks/we/html/IconHalo": [
		"25b4",
		9,
		"components-base-frameworks-we-html-IconHalo"
	],
	"./components/base/frameworks/we/html/IconHalo.vue": [
		"25b4",
		9,
		"components-base-frameworks-we-html-IconHalo"
	],
	"./components/base/frameworks/we/html/IconText": [
		"a0a9",
		9,
		"components-base-frameworks-we-html-IconText"
	],
	"./components/base/frameworks/we/html/IconText.vue": [
		"a0a9",
		9,
		"components-base-frameworks-we-html-IconText"
	],
	"./components/base/frameworks/we/html/Inline": [
		"8144",
		9,
		"components-base-frameworks-we-html-Inline"
	],
	"./components/base/frameworks/we/html/Inline.vue": [
		"8144",
		9,
		"components-base-frameworks-we-html-Inline"
	],
	"./components/base/frameworks/we/html/InlineBlock": [
		"8d17",
		9,
		"components-base-frameworks-we-html-InlineBlock"
	],
	"./components/base/frameworks/we/html/InlineBlock.vue": [
		"8d17",
		9,
		"components-base-frameworks-we-html-InlineBlock"
	],
	"./components/base/frameworks/we/html/List": [
		"f974",
		9,
		"components-base-frameworks-we-html-List"
	],
	"./components/base/frameworks/we/html/List.vue": [
		"f974",
		9,
		"components-base-frameworks-we-html-List"
	],
	"./components/base/frameworks/we/html/ListItem": [
		"0cdf",
		9,
		"components-base-frameworks-we-html-ListItem"
	],
	"./components/base/frameworks/we/html/ListItem.vue": [
		"0cdf",
		9,
		"components-base-frameworks-we-html-ListItem"
	],
	"./components/base/frameworks/we/html/Paragraph": [
		"1f2d",
		9,
		"components-base-frameworks-we-html-Paragraph"
	],
	"./components/base/frameworks/we/html/Paragraph.vue": [
		"1f2d",
		9,
		"components-base-frameworks-we-html-Paragraph"
	],
	"./components/base/frameworks/we/html/RatioContainer": [
		"a22b",
		9,
		"components-base-frameworks-we-html-RatioContainer"
	],
	"./components/base/frameworks/we/html/RatioContainer.vue": [
		"a22b",
		9,
		"components-base-frameworks-we-html-RatioContainer"
	],
	"./components/base/frameworks/we/html/Spoiler": [
		"214d",
		9,
		"components-base-frameworks-we-html-Spoiler"
	],
	"./components/base/frameworks/we/html/Spoiler.vue": [
		"214d",
		9,
		"components-base-frameworks-we-html-Spoiler"
	],
	"./components/base/frameworks/we/layout/Grid": [
		"47a3",
		9,
		"components-base-frameworks-we-layout-Grid"
	],
	"./components/base/frameworks/we/layout/Grid.vue": [
		"47a3",
		9,
		"components-base-frameworks-we-layout-Grid"
	],
	"./components/base/frameworks/we/layout/GridColumn": [
		"9b5d",
		9,
		"components-base-frameworks-we-layout-GridColumn"
	],
	"./components/base/frameworks/we/layout/GridColumn.vue": [
		"9b5d",
		9,
		"components-base-frameworks-we-layout-GridColumn"
	],
	"./components/base/frameworks/we/loaders/barLoader": [
		"da79",
		9,
		"components-base-frameworks-we-loaders-barLoader"
	],
	"./components/base/frameworks/we/loaders/barLoader.vue": [
		"da79",
		9,
		"components-base-frameworks-we-loaders-barLoader"
	],
	"./components/base/frameworks/we/loaders/spinner": [
		"813e",
		9,
		"components-base-frameworks-we-loaders-spinner"
	],
	"./components/base/frameworks/we/loaders/spinner.vue": [
		"813e",
		9,
		"components-base-frameworks-we-loaders-spinner"
	],
	"./components/base/frameworks/we/modals/LargeImageModal": [
		"345c",
		9,
		"components-base-frameworks-we-modals-LargeImageModal"
	],
	"./components/base/frameworks/we/modals/LargeImageModal.vue": [
		"345c",
		9,
		"components-base-frameworks-we-modals-LargeImageModal"
	],
	"./components/base/frameworks/we/modals/YoutubeVideoModal": [
		"116a",
		9,
		"components-base-frameworks-we-modals-YoutubeVideoModal"
	],
	"./components/base/frameworks/we/modals/YoutubeVideoModal.vue": [
		"116a",
		9,
		"components-base-frameworks-we-modals-YoutubeVideoModal"
	],
	"./components/base/frameworks/we/notificationItems/NotificationItem": [
		"6b87",
		9,
		"components-base-frameworks-we-notificationItems-NotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/NotificationItem.vue": [
		"6b87",
		9,
		"components-base-frameworks-we-notificationItems-NotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/items/DefaultNotificationItem": [
		"33eb",
		9,
		"components-base-frameworks-we-notificationItems-items-DefaultNotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/items/DefaultNotificationItem.vue": [
		"33eb",
		9,
		"components-base-frameworks-we-notificationItems-items-DefaultNotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/items/Test2NotificationItem": [
		"6d7c",
		9,
		"components-base-frameworks-we-notificationItems-items-Test2NotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/items/Test2NotificationItem.vue": [
		"6d7c",
		9,
		"components-base-frameworks-we-notificationItems-items-Test2NotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/items/TestNotificationItem": [
		"2c12",
		9,
		"components-base-frameworks-we-notificationItems-items-TestNotificationItem"
	],
	"./components/base/frameworks/we/notificationItems/items/TestNotificationItem.vue": [
		"2c12",
		9,
		"components-base-frameworks-we-notificationItems-items-TestNotificationItem"
	],
	"./components/base/frameworks/we/quickEdit/QuickAction": [
		"dd6a",
		9,
		"components-base-frameworks-we-quickEdit-QuickAction"
	],
	"./components/base/frameworks/we/quickEdit/QuickAction.vue": [
		"dd6a",
		9,
		"components-base-frameworks-we-quickEdit-QuickAction"
	],
	"./components/base/frameworks/we/quickEdit/QuickEdit": [
		"0e93",
		9,
		"components-base-frameworks-we-quickEdit-QuickEdit"
	],
	"./components/base/frameworks/we/quickEdit/QuickEdit.vue": [
		"0e93",
		9,
		"components-base-frameworks-we-quickEdit-QuickEdit"
	],
	"./components/base/frameworks/we/quickEdit/QuickEditor": [
		"849c",
		9,
		"components-base-frameworks-we-quickEdit-QuickEditor"
	],
	"./components/base/frameworks/we/quickEdit/QuickEditor.vue": [
		"849c",
		9,
		"components-base-frameworks-we-quickEdit-QuickEditor"
	],
	"./components/base/frameworks/we/slider/Slide": [
		"b888",
		9,
		"components-base-frameworks-we-slider-Slide"
	],
	"./components/base/frameworks/we/slider/Slide.vue": [
		"b888",
		9,
		"components-base-frameworks-we-slider-Slide"
	],
	"./components/base/frameworks/we/slider/Slider": [
		"cf31",
		9,
		"components-base-frameworks-we-slider-Slider"
	],
	"./components/base/frameworks/we/slider/Slider.vue": [
		"cf31",
		9,
		"components-base-frameworks-we-slider-Slider"
	],
	"./components/base/frameworks/we/timeline/Timeline": [
		"a3df",
		9,
		"components-base-frameworks-we-timeline-Timeline"
	],
	"./components/base/frameworks/we/timeline/Timeline.vue": [
		"a3df",
		9,
		"components-base-frameworks-we-timeline-Timeline"
	],
	"./components/base/frameworks/we/timeline/TimelineItem": [
		"d320",
		9,
		"components-base-frameworks-we-timeline-TimelineItem"
	],
	"./components/base/frameworks/we/timeline/TimelineItem.vue": [
		"d320",
		9,
		"components-base-frameworks-we-timeline-TimelineItem"
	],
	"./components/chat/Chat": [
		"6e79",
		9,
		"components-chat-Chat"
	],
	"./components/chat/Chat.vue": [
		"6e79",
		9,
		"components-chat-Chat"
	],
	"./components/chat/ChatMessage": [
		"103a",
		9,
		"components-chat-ChatMessage"
	],
	"./components/chat/ChatMessage.vue": [
		"103a",
		9,
		"components-chat-ChatMessage"
	],
	"./components/chat/Conversations": [
		"d1ba",
		9,
		"components-chat-Conversations"
	],
	"./components/chat/Conversations.vue": [
		"d1ba",
		9,
		"components-chat-Conversations"
	],
	"./components/chat/SupportChat": [
		"4757",
		9,
		"components-chat-SupportChat"
	],
	"./components/chat/SupportChat.vue": [
		"4757",
		9,
		"components-chat-SupportChat"
	],
	"./components/chat/UserAvatar": [
		"0398",
		9,
		"components-chat-UserAvatar"
	],
	"./components/chat/UserAvatar.vue": [
		"0398",
		9,
		"components-chat-UserAvatar"
	],
	"./components/chat/VendorChat": [
		"d91a",
		9,
		"components-chat-VendorChat"
	],
	"./components/chat/VendorChat.vue": [
		"d91a",
		9,
		"components-chat-VendorChat"
	],
	"./components/crud/Create": [
		"571a",
		9,
		"components-crud-Create"
	],
	"./components/crud/Create.vue": [
		"571a",
		9,
		"components-crud-Create"
	],
	"./components/crud/Edit": [
		"0755",
		9,
		"components-crud-Edit"
	],
	"./components/crud/Edit.vue": [
		"0755",
		9,
		"components-crud-Edit"
	],
	"./components/crud/FileManager": [
		"a49a",
		9,
		"components-crud-FileManager"
	],
	"./components/crud/FileManager.vue": [
		"a49a",
		9,
		"components-crud-FileManager"
	],
	"./components/crud/List": [
		"49f3",
		9,
		"components-crud-List"
	],
	"./components/crud/List.vue": [
		"49f3",
		9,
		"components-crud-List"
	],
	"./components/crud/customV1/Create": [
		"65fc",
		9,
		"components-crud-customV1-Create"
	],
	"./components/crud/customV1/Create.vue": [
		"65fc",
		9,
		"components-crud-customV1-Create"
	],
	"./components/crud/customV1/Edit": [
		"dfd8",
		9,
		"components-crud-customV1-Edit"
	],
	"./components/crud/customV1/Edit.vue": [
		"dfd8",
		9,
		"components-crud-customV1-Edit"
	],
	"./components/crud/customV1/List": [
		"2ecf",
		9,
		"components-crud-customV1-List"
	],
	"./components/crud/customV1/List.vue": [
		"2ecf",
		9,
		"components-crud-customV1-List"
	],
	"./components/ecommerce/Cart": [
		"d2c2",
		9,
		"components-ecommerce-Cart"
	],
	"./components/ecommerce/Cart.vue": [
		"d2c2",
		9,
		"components-ecommerce-Cart"
	],
	"./components/ecommerce/OrderModal": [
		"cfcd",
		9,
		"components-ecommerce-OrderModal"
	],
	"./components/ecommerce/OrderModal.vue": [
		"cfcd",
		9,
		"components-ecommerce-OrderModal"
	],
	"./components/ecommerce/Review": [
		"33e9",
		9,
		"components-ecommerce-Review"
	],
	"./components/ecommerce/Review.vue": [
		"33e9",
		9,
		"components-ecommerce-Review"
	],
	"./components/ecommerce/address/CreateUserAddressModal": [
		"cd61",
		9,
		"components-ecommerce-address-CreateUserAddressModal"
	],
	"./components/ecommerce/address/CreateUserAddressModal.vue": [
		"cd61",
		9,
		"components-ecommerce-address-CreateUserAddressModal"
	],
	"./components/ecommerce/checkout/CheckoutStep": [
		"a5a4",
		9,
		"components-ecommerce-checkout-CheckoutStep"
	],
	"./components/ecommerce/checkout/CheckoutStep.vue": [
		"a5a4",
		9,
		"components-ecommerce-checkout-CheckoutStep"
	],
	"./components/ecommerce/checkout/steps/StandardPaymentMethodSelect": [
		"0c55",
		9,
		"components-ecommerce-checkout-steps-StandardPaymentMethodSelect"
	],
	"./components/ecommerce/checkout/steps/StandardPaymentMethodSelect.vue": [
		"0c55",
		9,
		"components-ecommerce-checkout-steps-StandardPaymentMethodSelect"
	],
	"./components/ecommerce/checkout/steps/StandardShippingAndAddress": [
		"7300",
		9,
		"components-ecommerce-checkout-steps-StandardShippingAndAddress"
	],
	"./components/ecommerce/checkout/steps/StandardShippingAndAddress.vue": [
		"7300",
		9,
		"components-ecommerce-checkout-steps-StandardShippingAndAddress"
	],
	"./components/ecommerce/review/CreateReview": [
		"573f",
		9,
		"components-ecommerce-review-CreateReview"
	],
	"./components/ecommerce/review/CreateReview.vue": [
		"573f",
		9,
		"components-ecommerce-review-CreateReview"
	],
	"./components/ecommerce/widgets/VendorChatWidget": [
		"7499",
		9,
		"components-ecommerce-widgets-VendorChatWidget"
	],
	"./components/ecommerce/widgets/VendorChatWidget.vue": [
		"7499",
		9,
		"components-ecommerce-widgets-VendorChatWidget"
	],
	"./components/etc/NotificationWidget": [
		"4baa",
		9,
		"components-etc-NotificationWidget"
	],
	"./components/etc/NotificationWidget.vue": [
		"4baa",
		9,
		"components-etc-NotificationWidget"
	],
	"./components/etc/RequireAuth": [
		"fdb3",
		9,
		"components-etc-RequireAuth"
	],
	"./components/etc/RequireAuth.vue": [
		"fdb3",
		9,
		"components-etc-RequireAuth"
	],
	"./components/nav/BaseSideNav": [
		"8d5b",
		9,
		"components-nav-BaseSideNav"
	],
	"./components/nav/BaseSideNav.vue": [
		"8d5b",
		9,
		"components-nav-BaseSideNav"
	],
	"./components/nav/NavInternalItem": [
		"426e",
		9,
		"components-nav-NavInternalItem"
	],
	"./components/nav/NavInternalItem.vue": [
		"426e",
		9,
		"components-nav-NavInternalItem"
	],
	"./components/payment/Payment": [
		"896b",
		9,
		"components-payment-Payment"
	],
	"./components/payment/Payment.vue": [
		"896b",
		9,
		"components-payment-Payment"
	],
	"./components/payment/templates/Offline": [
		"bb03",
		9,
		"components-payment-templates-Offline"
	],
	"./components/payment/templates/Offline.vue": [
		"bb03",
		9,
		"components-payment-templates-Offline"
	],
	"./components/payment/templates/Paypal": [
		"9893",
		9,
		"components-payment-templates-Paypal"
	],
	"./components/payment/templates/Paypal.vue": [
		"9893",
		9,
		"components-payment-templates-Paypal"
	],
	"./components/playground": [
		"2290",
		9,
		"components-playground"
	],
	"./components/playground.vue": [
		"2290",
		9,
		"components-playground"
	],
	"./components/test": [
		"5962",
		9,
		"components-test"
	],
	"./components/test.vue": [
		"5962",
		9,
		"components-test"
	],
	"./config": [
		"5ee7",
		9
	],
	"./config/": [
		"5ee7",
		9
	],
	"./config/config": [
		"8435",
		9
	],
	"./config/config.js": [
		"8435",
		9
	],
	"./config/index": [
		"5ee7",
		9
	],
	"./config/index.js": [
		"5ee7",
		9
	],
	"./config/modules/asyncData": [
		"ef1b",
		9
	],
	"./config/modules/asyncData.js": [
		"ef1b",
		9
	],
	"./config/modules/cookie": [
		"14f0",
		9
	],
	"./config/modules/cookie.js": [
		"14f0",
		9
	],
	"./config/modules/ecommerce": [
		"117f",
		9
	],
	"./config/modules/ecommerce.js": [
		"117f",
		9
	],
	"./config/modules/facebook": [
		"c13d",
		9
	],
	"./config/modules/facebook.js": [
		"c13d",
		9
	],
	"./config/modules/form": [
		"bbe9",
		9
	],
	"./config/modules/form.js": [
		"bbe9",
		9
	],
	"./config/modules/google": [
		"afc1",
		9
	],
	"./config/modules/google.js": [
		"afc1",
		9
	],
	"./config/modules/inactivityDisconnection": [
		"b34b",
		9
	],
	"./config/modules/inactivityDisconnection.js": [
		"b34b",
		9
	],
	"./config/modules/locale": [
		"4266",
		9
	],
	"./config/modules/locale.js": [
		"4266",
		9
	],
	"./config/modules/mediaManager": [
		"42fe",
		9
	],
	"./config/modules/mediaManager.js": [
		"42fe",
		9
	],
	"./config/modules/moduleB": [
		"7f5d",
		9
	],
	"./config/modules/moduleB.js": [
		"7f5d",
		9
	],
	"./config/modules/router": [
		"426a",
		9
	],
	"./config/modules/router.js": [
		"426a",
		9
	],
	"./config/modules/security": [
		"36fa",
		9
	],
	"./config/modules/security.js": [
		"36fa",
		9
	],
	"./config/modules/style": [
		"fb6f",
		9
	],
	"./config/modules/style.js": [
		"fb6f",
		9
	],
	"./config/modules/user": [
		"d5bc",
		9
	],
	"./config/modules/user.js": [
		"d5bc",
		9
	],
	"./config/root": [
		"787a",
		9
	],
	"./config/root.js": [
		"787a",
		9
	],
	"./extensions/composition/_pagination": [
		"111f",
		9,
		"extensions-composition-_pagination"
	],
	"./extensions/composition/_pagination.js": [
		"111f",
		9,
		"extensions-composition-_pagination"
	],
	"./extensions/composition/addWindowScript": [
		"e619",
		9,
		"extensions-composition-addWindowScript"
	],
	"./extensions/composition/addWindowScript.js": [
		"e619",
		9,
		"extensions-composition-addWindowScript"
	],
	"./extensions/composition/asyncOperations": [
		"1001",
		9
	],
	"./extensions/composition/asyncOperations.js": [
		"1001",
		9
	],
	"./extensions/composition/asyncOperations/asyncData": [
		"f6f5",
		9,
		"extensions-composition-asyncOperations-asyncData"
	],
	"./extensions/composition/asyncOperations/asyncData.js": [
		"f6f5",
		9,
		"extensions-composition-asyncOperations-asyncData"
	],
	"./extensions/composition/asyncOperations/requestAdapters/interface.class": [
		"8359",
		9,
		"requestAdapter0"
	],
	"./extensions/composition/asyncOperations/requestAdapters/interface.class.js": [
		"8359",
		9,
		"requestAdapter0"
	],
	"./extensions/composition/asyncOperations/requestAdapters/saffronAxios": [
		"f7c7",
		9,
		"requestAdapter2"
	],
	"./extensions/composition/asyncOperations/requestAdapters/saffronAxios.js": [
		"f7c7",
		9,
		"requestAdapter2"
	],
	"./extensions/composition/asyncOperations/responseAdapters/interface.class": [
		"e8c5",
		9,
		"responseAdapter0"
	],
	"./extensions/composition/asyncOperations/responseAdapters/interface.class.js": [
		"e8c5",
		9,
		"responseAdapter0"
	],
	"./extensions/composition/asyncOperations/responseAdapters/raw": [
		"494f",
		9,
		"responseAdapter2"
	],
	"./extensions/composition/asyncOperations/responseAdapters/raw.js": [
		"494f",
		9,
		"responseAdapter2"
	],
	"./extensions/composition/asyncOperations/responseAdapters/saffron": [
		"caf9",
		9,
		"responseAdapter4"
	],
	"./extensions/composition/asyncOperations/responseAdapters/saffron.js": [
		"caf9",
		9,
		"responseAdapter4"
	],
	"./extensions/composition/asyncOperations/responseObjectFactory": [
		"467e",
		9,
		"extensions-composition-asyncOperations-responseObjectFactory"
	],
	"./extensions/composition/asyncOperations/responseObjectFactory.js": [
		"467e",
		9,
		"extensions-composition-asyncOperations-responseObjectFactory"
	],
	"./extensions/composition/layout": [
		"5362",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"extensions-composition-layout"
	],
	"./extensions/composition/layout.js": [
		"5362",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"extensions-composition-layout"
	],
	"./extensions/composition/useBodyClass": [
		"e0e4",
		9,
		"extensions-composition-useBodyClass"
	],
	"./extensions/composition/useBodyClass.js": [
		"e0e4",
		9,
		"extensions-composition-useBodyClass"
	],
	"./extensions/composition/useCarts": [
		"c3d2",
		9,
		"extensions-composition-useCarts"
	],
	"./extensions/composition/useCarts.js": [
		"c3d2",
		9,
		"extensions-composition-useCarts"
	],
	"./extensions/composition/useChat": [
		"4ac7",
		9,
		"extensions-composition-useChat"
	],
	"./extensions/composition/useChat.js": [
		"4ac7",
		9,
		"extensions-composition-useChat"
	],
	"./extensions/composition/useCurrency": [
		"4063",
		9,
		"extensions-composition-useCurrency"
	],
	"./extensions/composition/useCurrency.js": [
		"4063",
		9,
		"extensions-composition-useCurrency"
	],
	"./extensions/composition/useDom": [
		"1b76",
		9,
		"extensions-composition-useDom"
	],
	"./extensions/composition/useDom.js": [
		"1b76",
		9,
		"extensions-composition-useDom"
	],
	"./extensions/composition/useFiles": [
		"dfdc",
		9,
		"chunk-3f011d14",
		"extensions-composition-useFiles"
	],
	"./extensions/composition/useFiles.js": [
		"dfdc",
		9,
		"chunk-3f011d14",
		"extensions-composition-useFiles"
	],
	"./extensions/composition/useListIterator": [
		"e769",
		9,
		"extensions-composition-useListIterator"
	],
	"./extensions/composition/useListIterator.js": [
		"e769",
		9,
		"extensions-composition-useListIterator"
	],
	"./extensions/composition/useMediaManager": [
		"3156",
		9,
		"extensions-composition-useMediaManager"
	],
	"./extensions/composition/useMediaManager.js": [
		"3156",
		9,
		"extensions-composition-useMediaManager"
	],
	"./extensions/composition/useNetworkQuality": [
		"b1bf",
		9,
		"extensions-composition-useNetworkQuality"
	],
	"./extensions/composition/useNetworkQuality.js": [
		"b1bf",
		9,
		"extensions-composition-useNetworkQuality"
	],
	"./extensions/composition/useProducts": [
		"995a",
		9,
		"extensions-composition-useProducts"
	],
	"./extensions/composition/useProducts.js": [
		"995a",
		9,
		"extensions-composition-useProducts"
	],
	"./extensions/composition/useQuickEdit": [
		"9471",
		9,
		"extensions-composition-useQuickEdit"
	],
	"./extensions/composition/useQuickEdit.js": [
		"9471",
		9,
		"extensions-composition-useQuickEdit"
	],
	"./extensions/composition/useRecaptcha": [
		"a44b",
		9
	],
	"./extensions/composition/useRecaptcha.js": [
		"a44b",
		9
	],
	"./extensions/composition/useSocialLogin": [
		"b71d",
		9,
		"extensions-composition-useSocialLogin"
	],
	"./extensions/composition/useSocialLogin.js": [
		"b71d",
		9,
		"extensions-composition-useSocialLogin"
	],
	"./extensions/composition/useTempStylesheet": [
		"1b51",
		9,
		"extensions-composition-useTempStylesheet"
	],
	"./extensions/composition/useTempStylesheet.js": [
		"1b51",
		9,
		"extensions-composition-useTempStylesheet"
	],
	"./extensions/composition/useValidation": [
		"ee68",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"extensions-composition-useValidation"
	],
	"./extensions/composition/useValidation.js": [
		"ee68",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"extensions-composition-useValidation"
	],
	"./extensions/composition/useWindowScroll": [
		"553f",
		9,
		"extensions-composition-useWindowScroll"
	],
	"./extensions/composition/useWindowScroll.js": [
		"553f",
		9,
		"extensions-composition-useWindowScroll"
	],
	"./extensions/composition/useWindowSize": [
		"918c",
		9,
		"extensions-composition-useWindowSize"
	],
	"./extensions/composition/useWindowSize.js": [
		"918c",
		9,
		"extensions-composition-useWindowSize"
	],
	"./extensions/directives": [
		"b289",
		9,
		"extensions-directives"
	],
	"./extensions/directives/": [
		"b289",
		9,
		"extensions-directives"
	],
	"./extensions/directives/directives/click-outside": [
		"382f",
		9,
		"extensions-directives-directives-click-outside"
	],
	"./extensions/directives/directives/click-outside.js": [
		"382f",
		9,
		"extensions-directives-directives-click-outside"
	],
	"./extensions/directives/directives/dropdown": [
		"5a27",
		9,
		"extensions-directives-directives-dropdown"
	],
	"./extensions/directives/directives/dropdown.js": [
		"5a27",
		9,
		"extensions-directives-directives-dropdown"
	],
	"./extensions/directives/directives/intersect": [
		"9f96",
		9,
		"extensions-directives-directives-intersect"
	],
	"./extensions/directives/directives/intersect.js": [
		"9f96",
		9,
		"extensions-directives-directives-intersect"
	],
	"./extensions/directives/directives/rellax": [
		"a7e3",
		9,
		"extensions-directives-directives-rellax"
	],
	"./extensions/directives/directives/rellax.js": [
		"a7e3",
		9,
		"extensions-directives-directives-rellax"
	],
	"./extensions/directives/directives/responsiveClasses": [
		"6ddd",
		9,
		"extensions-directives-directives-responsiveClasses"
	],
	"./extensions/directives/directives/responsiveClasses.js": [
		"6ddd",
		9,
		"extensions-directives-directives-responsiveClasses"
	],
	"./extensions/directives/directives/sortable": [
		"2e29",
		9,
		"extensions-directives-directives-sortable"
	],
	"./extensions/directives/directives/sortable.js": [
		"2e29",
		9,
		"extensions-directives-directives-sortable"
	],
	"./extensions/directives/directives/tempClassOn": [
		"1787",
		9,
		"extensions-directives-directives-tempClassOn"
	],
	"./extensions/directives/directives/tempClassOn.js": [
		"1787",
		9,
		"extensions-directives-directives-tempClassOn"
	],
	"./extensions/directives/directives/tooltip": [
		"1c3d",
		9,
		"extensions-directives-directives-tooltip"
	],
	"./extensions/directives/directives/tooltip.js": [
		"1c3d",
		9,
		"extensions-directives-directives-tooltip"
	],
	"./extensions/directives/index": [
		"b289",
		9,
		"extensions-directives"
	],
	"./extensions/directives/index.js": [
		"b289",
		9,
		"extensions-directives"
	],
	"./extensions/mixins/baseComponents/alert": [
		"60e6",
		9,
		"extensions-mixins-baseComponents-alert"
	],
	"./extensions/mixins/baseComponents/alert.js": [
		"60e6",
		9,
		"extensions-mixins-baseComponents-alert"
	],
	"./extensions/mixins/baseComponents/breadCrumbs": [
		"5d7e",
		9,
		"extensions-mixins-baseComponents-breadCrumbs"
	],
	"./extensions/mixins/baseComponents/breadCrumbs.js": [
		"5d7e",
		9,
		"extensions-mixins-baseComponents-breadCrumbs"
	],
	"./extensions/mixins/baseComponents/etc/InactivityDisconnect": [
		"4b39",
		9,
		"extensions-mixins-baseComponents-etc-InactivityDisconnect"
	],
	"./extensions/mixins/baseComponents/etc/InactivityDisconnect.js": [
		"4b39",
		9,
		"extensions-mixins-baseComponents-etc-InactivityDisconnect"
	],
	"./extensions/mixins/baseComponents/etc/LanguageSwitcher": [
		"3233",
		9,
		"extensions-mixins-baseComponents-etc-LanguageSwitcher"
	],
	"./extensions/mixins/baseComponents/etc/LanguageSwitcher.js": [
		"3233",
		9,
		"extensions-mixins-baseComponents-etc-LanguageSwitcher"
	],
	"./extensions/mixins/baseComponents/etc/badge": [
		"52ec",
		9,
		"extensions-mixins-baseComponents-etc-badge"
	],
	"./extensions/mixins/baseComponents/etc/badge.js": [
		"52ec",
		9,
		"extensions-mixins-baseComponents-etc-badge"
	],
	"./extensions/mixins/baseComponents/etc/drawer": [
		"e029",
		9,
		"extensions-mixins-baseComponents-etc-drawer"
	],
	"./extensions/mixins/baseComponents/etc/drawer.js": [
		"e029",
		9,
		"extensions-mixins-baseComponents-etc-drawer"
	],
	"./extensions/mixins/baseComponents/etc/socialShare": [
		"997e",
		9,
		"extensions-mixins-baseComponents-etc-socialShare"
	],
	"./extensions/mixins/baseComponents/etc/socialShare.js": [
		"997e",
		9,
		"extensions-mixins-baseComponents-etc-socialShare"
	],
	"./extensions/mixins/baseComponents/floatingWidget": [
		"4468",
		9,
		"extensions-mixins-baseComponents-floatingWidget"
	],
	"./extensions/mixins/baseComponents/floatingWidget.js": [
		"4468",
		9,
		"extensions-mixins-baseComponents-floatingWidget"
	],
	"./extensions/mixins/baseComponents/form/baseForm": [
		"0f50",
		9,
		"extensions-mixins-baseComponents-form-baseForm"
	],
	"./extensions/mixins/baseComponents/form/baseForm.js": [
		"0f50",
		9,
		"extensions-mixins-baseComponents-form-baseForm"
	],
	"./extensions/mixins/baseComponents/form/controls/formInput": [
		"933e",
		9,
		"extensions-mixins-baseComponents-form-controls-formInput"
	],
	"./extensions/mixins/baseComponents/form/controls/formInput.js": [
		"933e",
		9,
		"extensions-mixins-baseComponents-form-controls-formInput"
	],
	"./extensions/mixins/baseComponents/form/controls/freeLabel": [
		"785a",
		9,
		"extensions-mixins-baseComponents-form-controls-freeLabel"
	],
	"./extensions/mixins/baseComponents/form/controls/freeLabel.js": [
		"785a",
		9,
		"extensions-mixins-baseComponents-form-controls-freeLabel"
	],
	"./extensions/mixins/baseComponents/form/controls/input/colorInput": [
		"d6a9",
		9,
		"extensions-mixins-baseComponents-form-controls-input-colorInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/colorInput.js": [
		"d6a9",
		9,
		"extensions-mixins-baseComponents-form-controls-input-colorInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/countryListInput": [
		"9138",
		9,
		"extensions-mixins-baseComponents-form-controls-input-countryListInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/countryListInput.js": [
		"9138",
		9,
		"extensions-mixins-baseComponents-form-controls-input-countryListInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/currencyInput": [
		"3735",
		9,
		"extensions-mixins-baseComponents-form-controls-input-currencyInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/currencyInput.js": [
		"3735",
		9,
		"extensions-mixins-baseComponents-form-controls-input-currencyInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/dateInput": [
		"1376",
		9,
		"extensions-mixins-baseComponents-form-controls-input-dateInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/dateInput.js": [
		"1376",
		9,
		"extensions-mixins-baseComponents-form-controls-input-dateInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/editorInput": [
		"bafc",
		9,
		"extensions-mixins-baseComponents-form-controls-input-editorInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/editorInput.js": [
		"bafc",
		9,
		"extensions-mixins-baseComponents-form-controls-input-editorInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/i18nPhoneNumberInput": [
		"6f61",
		9,
		"extensions-mixins-baseComponents-form-controls-input-i18nPhoneNumberInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/i18nPhoneNumberInput.js": [
		"6f61",
		9,
		"extensions-mixins-baseComponents-form-controls-input-i18nPhoneNumberInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/localeInput": [
		"a6db",
		9,
		"extensions-mixins-baseComponents-form-controls-input-localeInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/localeInput.js": [
		"a6db",
		9,
		"extensions-mixins-baseComponents-form-controls-input-localeInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/passwordInput": [
		"59bd",
		9,
		"extensions-mixins-baseComponents-form-controls-input-passwordInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/passwordInput.js": [
		"59bd",
		9,
		"extensions-mixins-baseComponents-form-controls-input-passwordInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/priceInput": [
		"ecef",
		9,
		"extensions-mixins-baseComponents-form-controls-input-priceInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/priceInput.js": [
		"ecef",
		9,
		"extensions-mixins-baseComponents-form-controls-input-priceInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/rangeInput": [
		"48d1",
		9,
		"extensions-mixins-baseComponents-form-controls-input-rangeInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/rangeInput.js": [
		"48d1",
		9,
		"extensions-mixins-baseComponents-form-controls-input-rangeInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/repeatableInput": [
		"2e80",
		9,
		"extensions-mixins-baseComponents-form-controls-input-repeatableInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/repeatableInput.js": [
		"2e80",
		9,
		"extensions-mixins-baseComponents-form-controls-input-repeatableInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/select2/itemIcon": [
		"4f7d",
		9,
		"extensions-mixins-baseComponents-form-controls-input-select2-itemIcon"
	],
	"./extensions/mixins/baseComponents/form/controls/input/select2/itemIcon.js": [
		"4f7d",
		9,
		"extensions-mixins-baseComponents-form-controls-input-select2-itemIcon"
	],
	"./extensions/mixins/baseComponents/form/controls/input/select2Input": [
		"b8dd",
		9,
		"extensions-mixins-baseComponents-form-controls-input-select2Input"
	],
	"./extensions/mixins/baseComponents/form/controls/input/select2Input.js": [
		"b8dd",
		9,
		"extensions-mixins-baseComponents-form-controls-input-select2Input"
	],
	"./extensions/mixins/baseComponents/form/controls/input/selectInput": [
		"b86d",
		9,
		"extensions-mixins-baseComponents-form-controls-input-selectInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/selectInput.js": [
		"b86d",
		9,
		"extensions-mixins-baseComponents-form-controls-input-selectInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/simpleInput": [
		"ce4b",
		9,
		"extensions-mixins-baseComponents-form-controls-input-simpleInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/simpleInput.js": [
		"ce4b",
		9,
		"extensions-mixins-baseComponents-form-controls-input-simpleInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/textAreaInput": [
		"e588",
		9,
		"extensions-mixins-baseComponents-form-controls-input-textAreaInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/textAreaInput.js": [
		"e588",
		9,
		"extensions-mixins-baseComponents-form-controls-input-textAreaInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/toggleInput": [
		"8d0a",
		9,
		"extensions-mixins-baseComponents-form-controls-input-toggleInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/toggleInput.js": [
		"8d0a",
		9,
		"extensions-mixins-baseComponents-form-controls-input-toggleInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/translationsInput": [
		"360a",
		9,
		"extensions-mixins-baseComponents-form-controls-input-translationsInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/translationsInput.js": [
		"360a",
		9,
		"extensions-mixins-baseComponents-form-controls-input-translationsInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/unitsInput": [
		"4f45",
		9,
		"extensions-mixins-baseComponents-form-controls-input-unitsInput"
	],
	"./extensions/mixins/baseComponents/form/controls/input/unitsInput.js": [
		"4f45",
		9,
		"extensions-mixins-baseComponents-form-controls-input-unitsInput"
	],
	"./extensions/mixins/baseComponents/form/controls/select2Input": [
		"8949",
		9,
		"extensions-mixins-baseComponents-form-controls-select2Input"
	],
	"./extensions/mixins/baseComponents/form/controls/select2Input.js": [
		"8949",
		9,
		"extensions-mixins-baseComponents-form-controls-select2Input"
	],
	"./extensions/mixins/baseComponents/form/formButton": [
		"069f",
		9,
		"extensions-mixins-baseComponents-form-formButton"
	],
	"./extensions/mixins/baseComponents/form/formButton.js": [
		"069f",
		9,
		"extensions-mixins-baseComponents-form-formButton"
	],
	"./extensions/mixins/baseComponents/form/formFieldSet": [
		"73e8",
		9,
		"extensions-mixins-baseComponents-form-formFieldSet"
	],
	"./extensions/mixins/baseComponents/form/formFieldSet.js": [
		"73e8",
		9,
		"extensions-mixins-baseComponents-form-formFieldSet"
	],
	"./extensions/mixins/baseComponents/html/buttonGroup": [
		"bf32",
		9,
		"extensions-mixins-baseComponents-html-buttonGroup"
	],
	"./extensions/mixins/baseComponents/html/buttonGroup.js": [
		"bf32",
		9,
		"extensions-mixins-baseComponents-html-buttonGroup"
	],
	"./extensions/mixins/baseComponents/html/contentBlock": [
		"f747",
		9,
		"extensions-mixins-baseComponents-html-contentBlock"
	],
	"./extensions/mixins/baseComponents/html/contentBlock.js": [
		"f747",
		9,
		"extensions-mixins-baseComponents-html-contentBlock"
	],
	"./extensions/mixins/baseComponents/html/contentBlocks": [
		"abb0",
		9,
		"extensions-mixins-baseComponents-html-contentBlocks"
	],
	"./extensions/mixins/baseComponents/html/contentBlocks.js": [
		"abb0",
		9,
		"extensions-mixins-baseComponents-html-contentBlocks"
	],
	"./extensions/mixins/baseComponents/html/icon": [
		"36f3",
		9,
		"extensions-mixins-baseComponents-html-icon"
	],
	"./extensions/mixins/baseComponents/html/icon.js": [
		"36f3",
		9,
		"extensions-mixins-baseComponents-html-icon"
	],
	"./extensions/mixins/baseComponents/html/iconHalo": [
		"db83",
		9,
		"extensions-mixins-baseComponents-html-iconHalo"
	],
	"./extensions/mixins/baseComponents/html/iconHalo.js": [
		"db83",
		9,
		"extensions-mixins-baseComponents-html-iconHalo"
	],
	"./extensions/mixins/baseComponents/html/iconText": [
		"12a1",
		9,
		"extensions-mixins-baseComponents-html-iconText"
	],
	"./extensions/mixins/baseComponents/html/iconText.js": [
		"12a1",
		9,
		"extensions-mixins-baseComponents-html-iconText"
	],
	"./extensions/mixins/baseComponents/html/spoiler": [
		"60ae",
		9,
		"extensions-mixins-baseComponents-html-spoiler"
	],
	"./extensions/mixins/baseComponents/html/spoiler.js": [
		"60ae",
		9,
		"extensions-mixins-baseComponents-html-spoiler"
	],
	"./extensions/mixins/baseComponents/loaders/barLoader": [
		"9fb2",
		9,
		"extensions-mixins-baseComponents-loaders-barLoader"
	],
	"./extensions/mixins/baseComponents/loaders/barLoader.js": [
		"9fb2",
		9,
		"extensions-mixins-baseComponents-loaders-barLoader"
	],
	"./extensions/mixins/baseComponents/loaders/spinner": [
		"bda4",
		9,
		"extensions-mixins-baseComponents-loaders-spinner"
	],
	"./extensions/mixins/baseComponents/loaders/spinner.js": [
		"bda4",
		9,
		"extensions-mixins-baseComponents-loaders-spinner"
	],
	"./extensions/mixins/baseComponents/mediaManager": [
		"ef65",
		9,
		"extensions-mixins-baseComponents-mediaManager"
	],
	"./extensions/mixins/baseComponents/mediaManager.js": [
		"ef65",
		9,
		"extensions-mixins-baseComponents-mediaManager"
	],
	"./extensions/mixins/baseComponents/modal": [
		"87d8",
		9,
		"extensions-mixins-baseComponents-modal"
	],
	"./extensions/mixins/baseComponents/modal.js": [
		"87d8",
		9,
		"extensions-mixins-baseComponents-modal"
	],
	"./extensions/mixins/baseComponents/notification": [
		"0251",
		9,
		"extensions-mixins-baseComponents-notification"
	],
	"./extensions/mixins/baseComponents/notification.js": [
		"0251",
		9,
		"extensions-mixins-baseComponents-notification"
	],
	"./extensions/mixins/baseComponents/notificationItem": [
		"4b33",
		9,
		"extensions-mixins-baseComponents-notificationItem"
	],
	"./extensions/mixins/baseComponents/notificationItem.js": [
		"4b33",
		9,
		"extensions-mixins-baseComponents-notificationItem"
	],
	"./extensions/mixins/baseComponents/pagination": [
		"28d5",
		9,
		"extensions-mixins-baseComponents-pagination"
	],
	"./extensions/mixins/baseComponents/pagination.js": [
		"28d5",
		9,
		"extensions-mixins-baseComponents-pagination"
	],
	"./extensions/mixins/baseComponents/skeleton": [
		"36a4",
		9,
		"extensions-mixins-baseComponents-skeleton"
	],
	"./extensions/mixins/baseComponents/skeleton.js": [
		"36a4",
		9,
		"extensions-mixins-baseComponents-skeleton"
	],
	"./extensions/mixins/baseComponents/tabs": [
		"72cd",
		9,
		"extensions-mixins-baseComponents-tabs"
	],
	"./extensions/mixins/baseComponents/tabs.js": [
		"72cd",
		9,
		"extensions-mixins-baseComponents-tabs"
	],
	"./extensions/mixins/notificationCenter": [
		"1d42",
		9,
		"extensions-mixins-notificationCenter"
	],
	"./extensions/mixins/notificationCenter.js": [
		"1d42",
		9,
		"extensions-mixins-notificationCenter"
	],
	"./extensions/mixins/paymentComponent": [
		"5ace",
		9,
		"extensions-mixins-paymentComponent"
	],
	"./extensions/mixins/paymentComponent.js": [
		"5ace",
		9,
		"extensions-mixins-paymentComponent"
	],
	"./extensions/mixins/scrollToSection": [
		"bf4f",
		9,
		"extensions-mixins-scrollToSection"
	],
	"./extensions/mixins/scrollToSection.js": [
		"bf4f",
		9,
		"extensions-mixins-scrollToSection"
	],
	"./extensions/modules/asyncComponentFactory": [
		"49ed",
		9
	],
	"./extensions/modules/asyncComponentFactory.js": [
		"49ed",
		9
	],
	"./extensions/plugins": [
		"20d8",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"extensions-plugins"
	],
	"./extensions/plugins/": [
		"20d8",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"extensions-plugins"
	],
	"./extensions/plugins/_utilities": [
		"edbe",
		9,
		"extensions-plugins-_utilities"
	],
	"./extensions/plugins/_utilities.js": [
		"edbe",
		9,
		"extensions-plugins-_utilities"
	],
	"./extensions/plugins/asyncData": [
		"b638",
		9,
		"chunk-3f011d14",
		"extensions-plugins-asyncData"
	],
	"./extensions/plugins/asyncData.js": [
		"b638",
		9,
		"chunk-3f011d14",
		"extensions-plugins-asyncData"
	],
	"./extensions/plugins/baseComponentsGlobalizer": [
		"ef86",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"extensions-plugins-baseComponentsGlobalizer"
	],
	"./extensions/plugins/baseComponentsGlobalizer.js": [
		"ef86",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"extensions-plugins-baseComponentsGlobalizer"
	],
	"./extensions/plugins/cookie": [
		"ea1c",
		9,
		"extensions-plugins-cookie"
	],
	"./extensions/plugins/cookie.js": [
		"ea1c",
		9,
		"extensions-plugins-cookie"
	],
	"./extensions/plugins/dynamicAssets": [
		"8677",
		9,
		"extensions-plugins-dynamicAssets"
	],
	"./extensions/plugins/dynamicAssets.js": [
		"8677",
		9,
		"extensions-plugins-dynamicAssets"
	],
	"./extensions/plugins/genericStoreAccessor": [
		"0e03",
		9,
		"extensions-plugins-genericStoreAccessor"
	],
	"./extensions/plugins/genericStoreAccessor.js": [
		"0e03",
		9,
		"extensions-plugins-genericStoreAccessor"
	],
	"./extensions/plugins/i18n": [
		"d7fa",
		9,
		"extensions-plugins-i18n"
	],
	"./extensions/plugins/i18n.js": [
		"d7fa",
		9,
		"extensions-plugins-i18n"
	],
	"./extensions/plugins/index": [
		"20d8",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"extensions-plugins"
	],
	"./extensions/plugins/index.js": [
		"20d8",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"extensions-plugins"
	],
	"./extensions/plugins/layouts": [
		"9272",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"extensions-plugins-layouts~layouts-adminDashboard",
		"extensions-plugins-layouts"
	],
	"./extensions/plugins/layouts.js": [
		"9272",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"extensions-plugins-layouts~layouts-adminDashboard",
		"extensions-plugins-layouts"
	],
	"./extensions/plugins/performWithUi": [
		"ce98",
		9,
		"extensions-plugins-performWithUi"
	],
	"./extensions/plugins/performWithUi.js": [
		"ce98",
		9,
		"extensions-plugins-performWithUi"
	],
	"./extensions/plugins/playground": [
		"65a4",
		9,
		"extensions-plugins-playground"
	],
	"./extensions/plugins/playground.js": [
		"65a4",
		9,
		"extensions-plugins-playground"
	],
	"./extensions/plugins/saffron": [
		"7de0",
		9,
		"extensions-plugins-saffron"
	],
	"./extensions/plugins/saffron.js": [
		"7de0",
		9,
		"extensions-plugins-saffron"
	],
	"./extensions/plugins/user": [
		"cd32",
		9,
		"extensions-plugins-user"
	],
	"./extensions/plugins/user.js": [
		"cd32",
		9,
		"extensions-plugins-user"
	],
	"./extensions/plugins/vuelidate": [
		"8f3e",
		9,
		"extensions-plugins-vuelidate"
	],
	"./extensions/plugins/vuelidate.js": [
		"8f3e",
		9,
		"extensions-plugins-vuelidate"
	],
	"./extensions/plugins/vuemeta": [
		"02c7",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"extensions-plugins-vuemeta"
	],
	"./extensions/plugins/vuemeta.js": [
		"02c7",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"extensions-plugins-vuemeta"
	],
	"./extensions/validation": [
		"393d",
		9,
		"extensions-validation"
	],
	"./extensions/validation/": [
		"393d",
		9,
		"extensions-validation"
	],
	"./extensions/validation/index": [
		"393d",
		9,
		"extensions-validation"
	],
	"./extensions/validation/index.js": [
		"393d",
		9,
		"extensions-validation"
	],
	"./extensions/validation/validatorFactories/inList": [
		"f10a",
		9,
		"extensions-validation-validatorFactories-inList"
	],
	"./extensions/validation/validatorFactories/inList.js": [
		"f10a",
		9,
		"extensions-validation-validatorFactories-inList"
	],
	"./extensions/validation/validatorFactories/liveServerSide": [
		"d38a",
		9,
		"extensions-validation-validatorFactories-liveServerSide"
	],
	"./extensions/validation/validatorFactories/liveServerSide.js": [
		"d38a",
		9,
		"extensions-validation-validatorFactories-liveServerSide"
	],
	"./extensions/validation/validatorFactories/uniqueEmail": [
		"ed06",
		9,
		"extensions-validation-validatorFactories-uniqueEmail"
	],
	"./extensions/validation/validatorFactories/uniqueEmail.js": [
		"ed06",
		9,
		"extensions-validation-validatorFactories-uniqueEmail"
	],
	"./extensions/validation/validatorFactories/uniqueValue": [
		"3c7c",
		9,
		"extensions-validation-validatorFactories-uniqueValue"
	],
	"./extensions/validation/validatorFactories/uniqueValue.js": [
		"3c7c",
		9,
		"extensions-validation-validatorFactories-uniqueValue"
	],
	"./extensions/validation/validators/aliasPattern": [
		"9d79",
		9,
		"extensions-validation-validators-aliasPattern"
	],
	"./extensions/validation/validators/aliasPattern.js": [
		"9d79",
		9,
		"extensions-validation-validators-aliasPattern"
	],
	"./extensions/validation/validators/boolean": [
		"7b7c",
		9,
		"extensions-validation-validators-boolean"
	],
	"./extensions/validation/validators/boolean.js": [
		"7b7c",
		9,
		"extensions-validation-validators-boolean"
	],
	"./extensions/validation/validators/fullName": [
		"665f",
		9,
		"extensions-validation-validators-fullName"
	],
	"./extensions/validation/validators/fullName.js": [
		"665f",
		9,
		"extensions-validation-validators-fullName"
	],
	"./extensions/validation/validators/mustBeCool": [
		"b98a",
		9,
		"extensions-validation-validators-mustBeCool"
	],
	"./extensions/validation/validators/mustBeCool.js": [
		"b98a",
		9,
		"extensions-validation-validators-mustBeCool"
	],
	"./extensions/validation/validators/strinctBoolean": [
		"a6ac",
		9,
		"extensions-validation-validators-strinctBoolean"
	],
	"./extensions/validation/validators/strinctBoolean.js": [
		"a6ac",
		9,
		"extensions-validation-validators-strinctBoolean"
	],
	"./extensions/validation/validators/string": [
		"fe56",
		9,
		"extensions-validation-validators-string"
	],
	"./extensions/validation/validators/string.js": [
		"fe56",
		9,
		"extensions-validation-validators-string"
	],
	"./layouts/adminDashboard": [
		"86c0",
		9,
		"extensions-plugins-layouts~layouts-adminDashboard",
		"layouts-adminDashboard"
	],
	"./layouts/adminDashboard.vue": [
		"86c0",
		9,
		"extensions-plugins-layouts~layouts-adminDashboard",
		"layouts-adminDashboard"
	],
	"./layouts/adminDashboardView": [
		"60b6",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"layouts-adminDashboardView"
	],
	"./layouts/adminDashboardView.vue": [
		"60b6",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"layouts-adminDashboardView"
	],
	"./layouts/boxy": [
		"4cba",
		9,
		"layouts-boxy"
	],
	"./layouts/boxy.vue": [
		"4cba",
		9,
		"layouts-boxy"
	],
	"./layouts/default": [
		"ad75",
		9,
		"layouts-default"
	],
	"./layouts/default.vue": [
		"ad75",
		9,
		"layouts-default"
	],
	"./layouts/none": [
		"ec92",
		9,
		"layouts-none"
	],
	"./layouts/none.vue": [
		"ec92",
		9,
		"layouts-none"
	],
	"./layouts/sidecut": [
		"e891",
		9,
		"layouts-sidecut"
	],
	"./layouts/sidecut.vue": [
		"e891",
		9,
		"layouts-sidecut"
	],
	"./layouts/test": [
		"c549",
		9,
		"layouts-test"
	],
	"./layouts/test.vue": [
		"c549",
		9,
		"layouts-test"
	],
	"./layouts/userDashboard": [
		"7810",
		9,
		"layouts-userDashboard"
	],
	"./layouts/userDashboard.vue": [
		"7810",
		9,
		"layouts-userDashboard"
	],
	"./locale/en-US/locale": [
		"9e19",
		9,
		"locale-en-US-locale"
	],
	"./locale/en-US/locale.js": [
		"9e19",
		9,
		"locale-en-US-locale"
	],
	"./locale/en-US/messages": [
		"2c5a",
		9
	],
	"./locale/en-US/messages.js": [
		"2c5a",
		9
	],
	"./locale/he-IL/locale": [
		"d53b",
		9,
		"locale-he-IL-locale"
	],
	"./locale/he-IL/locale.js": [
		"d53b",
		9,
		"locale-he-IL-locale"
	],
	"./locale/he-IL/messages": [
		"0b2c",
		9
	],
	"./locale/he-IL/messages.js": [
		"0b2c",
		9
	],
	"./main": [
		"303a",
		9
	],
	"./main.js": [
		"303a",
		9
	],
	"./mainServer": [
		"65d8",
		9,
		"mainServer"
	],
	"./mainServer.js": [
		"65d8",
		9,
		"mainServer"
	],
	"./pages/admin/acl": [
		"90ac",
		9,
		"pages-admin-acl"
	],
	"./pages/admin/acl/": [
		"90ac",
		9,
		"pages-admin-acl"
	],
	"./pages/admin/acl/index": [
		"90ac",
		9,
		"pages-admin-acl"
	],
	"./pages/admin/acl/index.vue": [
		"90ac",
		9,
		"pages-admin-acl"
	],
	"./pages/admin/media": [
		"a39f",
		9,
		"pages-admin-media"
	],
	"./pages/admin/media/": [
		"a39f",
		9,
		"pages-admin-media"
	],
	"./pages/admin/media/index": [
		"a39f",
		9,
		"pages-admin-media"
	],
	"./pages/admin/media/index.vue": [
		"a39f",
		9,
		"pages-admin-media"
	],
	"./pages/admin/order": [
		"a828",
		9,
		"components-crud-customV1-List",
		"pages-admin-order"
	],
	"./pages/admin/order/": [
		"a828",
		9,
		"components-crud-customV1-List",
		"pages-admin-order"
	],
	"./pages/admin/order/index": [
		"a828",
		9,
		"components-crud-customV1-List",
		"pages-admin-order"
	],
	"./pages/admin/order/index.vue": [
		"a828",
		9,
		"components-crud-customV1-List",
		"pages-admin-order"
	],
	"./pages/admin/product": [
		"b281",
		9,
		"components-crud-customV1-List",
		"pages-admin-product"
	],
	"./pages/admin/product/": [
		"b281",
		9,
		"components-crud-customV1-List",
		"pages-admin-product"
	],
	"./pages/admin/product/create": [
		"4d57",
		9,
		"pages-admin-product-create"
	],
	"./pages/admin/product/create.vue": [
		"4d57",
		9,
		"pages-admin-product-create"
	],
	"./pages/admin/product/edit/[id]": [
		"5c9d",
		9,
		"pages-admin-product-edit-id"
	],
	"./pages/admin/product/edit/[id].vue": [
		"5c9d",
		9,
		"pages-admin-product-edit-id"
	],
	"./pages/admin/product/index": [
		"b281",
		9,
		"components-crud-customV1-List",
		"pages-admin-product"
	],
	"./pages/admin/product/index.vue": [
		"b281",
		9,
		"components-crud-customV1-List",
		"pages-admin-product"
	],
	"./pages/admin/user": [
		"6c02",
		9,
		"components-crud-customV1-List",
		"pages-admin-user"
	],
	"./pages/admin/user/": [
		"6c02",
		9,
		"components-crud-customV1-List",
		"pages-admin-user"
	],
	"./pages/admin/user/index": [
		"6c02",
		9,
		"components-crud-customV1-List",
		"pages-admin-user"
	],
	"./pages/admin/user/index.vue": [
		"6c02",
		9,
		"components-crud-customV1-List",
		"pages-admin-user"
	],
	"./pages/admin/vendor": [
		"00a2",
		9,
		"components-crud-customV1-List",
		"pages-admin-vendor"
	],
	"./pages/admin/vendor/": [
		"00a2",
		9,
		"components-crud-customV1-List",
		"pages-admin-vendor"
	],
	"./pages/admin/vendor/create": [
		"7c32",
		9,
		"pages-admin-vendor-create"
	],
	"./pages/admin/vendor/create.vue": [
		"7c32",
		9,
		"pages-admin-vendor-create"
	],
	"./pages/admin/vendor/edit/[id]": [
		"b99f",
		9,
		"pages-admin-vendor-edit-id"
	],
	"./pages/admin/vendor/edit/[id].vue": [
		"b99f",
		9,
		"pages-admin-vendor-edit-id"
	],
	"./pages/admin/vendor/index": [
		"00a2",
		9,
		"components-crud-customV1-List",
		"pages-admin-vendor"
	],
	"./pages/admin/vendor/index.vue": [
		"00a2",
		9,
		"components-crud-customV1-List",
		"pages-admin-vendor"
	],
	"./pages/error": [
		"8614",
		9,
		"pages-error"
	],
	"./pages/error/": [
		"8614",
		9,
		"pages-error"
	],
	"./pages/error/index": [
		"8614",
		9,
		"pages-error"
	],
	"./pages/error/index.vue": [
		"8614",
		9,
		"pages-error"
	],
	"./pages/notifications": [
		"5135",
		9,
		"pages-notifications"
	],
	"./pages/notifications/": [
		"5135",
		9,
		"pages-notifications"
	],
	"./pages/notifications/index": [
		"5135",
		9,
		"pages-notifications"
	],
	"./pages/notifications/index.vue": [
		"5135",
		9,
		"pages-notifications"
	],
	"./pages/payments-playground": [
		"da8c",
		9,
		"pages-payments-playground"
	],
	"./pages/payments-playground.vue": [
		"da8c",
		9,
		"pages-payments-playground"
	],
	"./pages/store": [
		"93ac",
		9,
		"pages-store"
	],
	"./pages/store/": [
		"93ac",
		9,
		"pages-store"
	],
	"./pages/store/checkout": [
		"2bb9",
		9,
		"pages-store-checkout"
	],
	"./pages/store/checkout/": [
		"2bb9",
		9,
		"pages-store-checkout"
	],
	"./pages/store/checkout/complete": [
		"9d45",
		9,
		"pages-store-checkout-complete"
	],
	"./pages/store/checkout/complete/": [
		"9d45",
		9,
		"pages-store-checkout-complete"
	],
	"./pages/store/checkout/complete/index": [
		"9d45",
		9,
		"pages-store-checkout-complete"
	],
	"./pages/store/checkout/complete/index.vue": [
		"9d45",
		9,
		"pages-store-checkout-complete"
	],
	"./pages/store/checkout/index": [
		"2bb9",
		9,
		"pages-store-checkout"
	],
	"./pages/store/checkout/index.vue": [
		"2bb9",
		9,
		"pages-store-checkout"
	],
	"./pages/store/checkout/orderComplete": [
		"4c29",
		9,
		"pages-store-checkout-orderComplete"
	],
	"./pages/store/checkout/orderComplete.vue": [
		"4c29",
		9,
		"pages-store-checkout-orderComplete"
	],
	"./pages/store/checkout/orderpg": [
		"2fb4",
		9,
		"pages-store-checkout-orderpg"
	],
	"./pages/store/checkout/orderpg.vue": [
		"2fb4",
		9,
		"pages-store-checkout-orderpg"
	],
	"./pages/store/checkout/standard": [
		"7fd0",
		9,
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"pages-store-checkout-standard"
	],
	"./pages/store/checkout/standard.vue": [
		"7fd0",
		9,
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"pages-store-checkout-standard"
	],
	"./pages/store/index": [
		"93ac",
		9,
		"pages-store"
	],
	"./pages/store/index.vue": [
		"93ac",
		9,
		"pages-store"
	],
	"./pages/store/vendor": [
		"f4a5",
		9,
		"pages-store-vendor"
	],
	"./pages/store/vendor/": [
		"f4a5",
		9,
		"pages-store-vendor"
	],
	"./pages/store/vendor/[id]": [
		"5c41",
		9,
		"pages-store-vendor-id"
	],
	"./pages/store/vendor/[id].vue": [
		"5c41",
		9,
		"pages-store-vendor-id"
	],
	"./pages/store/vendor/index": [
		"f4a5",
		9,
		"pages-store-vendor"
	],
	"./pages/store/vendor/index.vue": [
		"f4a5",
		9,
		"pages-store-vendor"
	],
	"./pages/user/activation": [
		"42ac",
		9,
		"pages-user-activation"
	],
	"./pages/user/activation.vue": [
		"42ac",
		9,
		"pages-user-activation"
	],
	"./pages/user/dashboard/conversations": [
		"0b79",
		9,
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"pages-user-dashboard-conversations"
	],
	"./pages/user/dashboard/conversations.vue": [
		"0b79",
		9,
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"pages-user-dashboard-conversations"
	],
	"./pages/user/dashboard/dashboard": [
		"1be6",
		9,
		"pages-user-dashboard-dashboard"
	],
	"./pages/user/dashboard/dashboard.vue": [
		"1be6",
		9,
		"pages-user-dashboard-dashboard"
	],
	"./pages/user/dashboard/help": [
		"00e6",
		9,
		"pages-user-dashboard-help"
	],
	"./pages/user/dashboard/help.vue": [
		"00e6",
		9,
		"pages-user-dashboard-help"
	],
	"./pages/user/dashboard/notifications": [
		"6c56",
		9,
		"pages-user-dashboard-notifications"
	],
	"./pages/user/dashboard/notifications.vue": [
		"6c56",
		9,
		"pages-user-dashboard-notifications"
	],
	"./pages/user/dashboard/orders": [
		"09a3",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-orders"
	],
	"./pages/user/dashboard/orders.vue": [
		"09a3",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-orders"
	],
	"./pages/user/dashboard/payments": [
		"19b7",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-payments"
	],
	"./pages/user/dashboard/payments.vue": [
		"19b7",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-payments"
	],
	"./pages/user/dashboard/profile": [
		"963e",
		9,
		"pages-user-dashboard-profile"
	],
	"./pages/user/dashboard/profile.vue": [
		"963e",
		9,
		"pages-user-dashboard-profile"
	],
	"./pages/user/dashboard/reviews": [
		"20b6",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-reviews"
	],
	"./pages/user/dashboard/reviews.vue": [
		"20b6",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-reviews"
	],
	"./pages/user/dashboard/vendor/dashboard": [
		"157c",
		9,
		"pages-user-dashboard-vendor-dashboard"
	],
	"./pages/user/dashboard/vendor/dashboard.vue": [
		"157c",
		9,
		"pages-user-dashboard-vendor-dashboard"
	],
	"./pages/user/dashboard/vendor/orders": [
		"479a",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-vendor-orders"
	],
	"./pages/user/dashboard/vendor/orders.vue": [
		"479a",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-vendor-orders"
	],
	"./pages/user/dashboard/vendor/products": [
		"f27e",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-vendor-products"
	],
	"./pages/user/dashboard/vendor/products.vue": [
		"f27e",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-vendor-products"
	],
	"./pages/user/dashboard/vendor/profile": [
		"3349",
		9,
		"pages-user-dashboard-vendor-profile"
	],
	"./pages/user/dashboard/vendor/profile.vue": [
		"3349",
		9,
		"pages-user-dashboard-vendor-profile"
	],
	"./pages/user/dashboard/vendor/reviews": [
		"4dc5",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-vendor-reviews"
	],
	"./pages/user/dashboard/vendor/reviews.vue": [
		"4dc5",
		9,
		"components-crud-customV1-List",
		"pages-user-dashboard-vendor-reviews"
	],
	"./pages/user/login": [
		"07db",
		9,
		"pages-user-login"
	],
	"./pages/user/login.vue": [
		"07db",
		9,
		"pages-user-login"
	],
	"./registerServiceWorker": [
		"9364",
		9
	],
	"./registerServiceWorker.js": [
		"9364",
		9
	],
	"./router": [
		"484b",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"router"
	],
	"./router/": [
		"484b",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"router"
	],
	"./router/index": [
		"484b",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"router"
	],
	"./router/index.js": [
		"484b",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"router"
	],
	"./router/middleware/adminGuard": [
		"07af",
		9,
		"router-middleware-adminGuard"
	],
	"./router/middleware/adminGuard.js": [
		"07af",
		9,
		"router-middleware-adminGuard"
	],
	"./router/middleware/bogle": [
		"e82f",
		9,
		"router-middleware-bogle"
	],
	"./router/middleware/bogle.js": [
		"e82f",
		9,
		"router-middleware-bogle"
	],
	"./router/middleware/guestGuard": [
		"62c8",
		9,
		"router-middleware-guestGuard"
	],
	"./router/middleware/guestGuard.js": [
		"62c8",
		9,
		"router-middleware-guestGuard"
	],
	"./router/middleware/layoutAccessor": [
		"59cc",
		9,
		"router-middleware-layoutAccessor"
	],
	"./router/middleware/layoutAccessor.js": [
		"59cc",
		9,
		"router-middleware-layoutAccessor"
	],
	"./router/middleware/metaAccessor": [
		"aa46",
		9,
		"router-middleware-metaAccessor"
	],
	"./router/middleware/metaAccessor.js": [
		"aa46",
		9,
		"router-middleware-metaAccessor"
	],
	"./router/middleware/pageServerPrefetch": [
		"a3b2",
		9,
		"router-middleware-pageServerPrefetch"
	],
	"./router/middleware/pageServerPrefetch.js": [
		"a3b2",
		9,
		"router-middleware-pageServerPrefetch"
	],
	"./router/middleware/requireNotVendor": [
		"9063",
		9,
		"router-middleware-requireNotVendor"
	],
	"./router/middleware/requireNotVendor.js": [
		"9063",
		9,
		"router-middleware-requireNotVendor"
	],
	"./router/middleware/requireSuperAdmin": [
		"1748",
		9,
		"router-middleware-requireSuperAdmin"
	],
	"./router/middleware/requireSuperAdmin.js": [
		"1748",
		9,
		"router-middleware-requireSuperAdmin"
	],
	"./router/middleware/requireUser": [
		"a587",
		9,
		"router-middleware-requireUser"
	],
	"./router/middleware/requireUser.js": [
		"a587",
		9,
		"router-middleware-requireUser"
	],
	"./router/middleware/test": [
		"06d0",
		9,
		"router-middleware-test"
	],
	"./router/middleware/test.js": [
		"06d0",
		9,
		"router-middleware-test"
	],
	"./router/middleware/userGuard.js": [
		"ad10",
		9,
		"router-middleware-userGuard-js"
	],
	"./router/middleware/userGuard.js.js": [
		"ad10",
		9,
		"router-middleware-userGuard-js"
	],
	"./router/middleware/waitForInitialUserFetch": [
		"57b0",
		9,
		"router-middleware-waitForInitialUserFetch"
	],
	"./router/middleware/waitForInitialUserFetch.js": [
		"57b0",
		9,
		"router-middleware-waitForInitialUserFetch"
	],
	"./router/readme.md": [
		"d33e",
		7,
		"router-readme-md"
	],
	"./router/router": [
		"6e37",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"router-router"
	],
	"./router/router.js": [
		"6e37",
		9,
		"components-crud-customV1-List",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"router-router"
	],
	"./router/routes/admin": [
		"e178",
		9,
		"router-routes-admin"
	],
	"./router/routes/admin.js": [
		"e178",
		9,
		"router-routes-admin"
	],
	"./router/routes/adminConfig": [
		"a893",
		9,
		"router-routes-adminConfig"
	],
	"./router/routes/adminConfig.js": [
		"a893",
		9,
		"router-routes-adminConfig"
	],
	"./router/routes/adminEntity": [
		"5f47",
		9,
		"router-routes-adminEntity"
	],
	"./router/routes/adminEntity.js": [
		"5f47",
		9,
		"router-routes-adminEntity"
	],
	"./router/routes/adminUser": [
		"f70a",
		9,
		"router-routes-adminUser"
	],
	"./router/routes/adminUser.js": [
		"f70a",
		9,
		"router-routes-adminUser"
	],
	"./router/routes/core": [
		"f98c",
		9,
		"router-routes-core"
	],
	"./router/routes/core.js": [
		"f98c",
		9,
		"router-routes-core"
	],
	"./router/routes/errors": [
		"c8b4",
		9,
		"router-routes-errors"
	],
	"./router/routes/errors.js": [
		"c8b4",
		9,
		"router-routes-errors"
	],
	"./router/routes/service": [
		"8236",
		9,
		"router-routes-service"
	],
	"./router/routes/service.js": [
		"8236",
		9,
		"router-routes-service"
	],
	"./router/routes/testApi": [
		"04f7",
		9,
		"router-routes-testApi"
	],
	"./router/routes/testApi.js": [
		"04f7",
		9,
		"router-routes-testApi"
	],
	"./router/routes/user": [
		"fd7e",
		9,
		"router-routes-user"
	],
	"./router/routes/user.js": [
		"fd7e",
		9,
		"router-routes-user"
	],
	"./router/routes/userDashboard": [
		"3206",
		9,
		"router-routes-userDashboard"
	],
	"./router/routes/userDashboard.js": [
		"3206",
		9,
		"router-routes-userDashboard"
	],
	"./router/saffronMiddlewareBus": [
		"4b5e",
		9,
		"router-saffronMiddlewareBus"
	],
	"./router/saffronMiddlewareBus.js": [
		"4b5e",
		9,
		"router-saffronMiddlewareBus"
	],
	"./router/utilities": [
		"5d70",
		9,
		"router-utilities"
	],
	"./router/utilities.js": [
		"5d70",
		9,
		"router-utilities"
	],
	"./store": [
		"195e",
		9,
		"chunk-3f011d14",
		"store-store",
		"store"
	],
	"./store/": [
		"195e",
		9,
		"chunk-3f011d14",
		"store-store",
		"store"
	],
	"./store/index": [
		"195e",
		9,
		"chunk-3f011d14",
		"store-store",
		"store"
	],
	"./store/index.js": [
		"195e",
		9,
		"chunk-3f011d14",
		"store-store",
		"store"
	],
	"./store/modules/asyncData": [
		"1bf4",
		9,
		"store-modules-asyncData"
	],
	"./store/modules/asyncData.js": [
		"1bf4",
		9,
		"store-modules-asyncData"
	],
	"./store/modules/carts": [
		"f532",
		9,
		"store-modules-carts"
	],
	"./store/modules/carts.js": [
		"f532",
		9,
		"store-modules-carts"
	],
	"./store/modules/chat": [
		"e041",
		9,
		"store-modules-chat"
	],
	"./store/modules/chat.js": [
		"e041",
		9,
		"store-modules-chat"
	],
	"./store/modules/config": [
		"3fea",
		9,
		"store-modules-config"
	],
	"./store/modules/config.js": [
		"3fea",
		9,
		"store-modules-config"
	],
	"./store/modules/crudList": [
		"0ada",
		9,
		"store-modules-crudList"
	],
	"./store/modules/crudList.js": [
		"0ada",
		9,
		"store-modules-crudList"
	],
	"./store/modules/currency": [
		"c658",
		9,
		"store-modules-currency"
	],
	"./store/modules/currency.js": [
		"c658",
		9,
		"store-modules-currency"
	],
	"./store/modules/locale": [
		"a6f3",
		9,
		"store-modules-locale"
	],
	"./store/modules/locale.js": [
		"a6f3",
		9,
		"store-modules-locale"
	],
	"./store/modules/something": [
		"803b",
		9,
		"store-modules-something"
	],
	"./store/modules/something.js": [
		"803b",
		9,
		"store-modules-something"
	],
	"./store/modules/ui": [
		"cbe4",
		9,
		"store-modules-ui"
	],
	"./store/modules/ui.js": [
		"cbe4",
		9,
		"store-modules-ui"
	],
	"./store/modules/user": [
		"c75e",
		9,
		"chunk-3f011d14",
		"store-modules-user"
	],
	"./store/modules/user.js": [
		"c75e",
		9,
		"chunk-3f011d14",
		"store-modules-user"
	],
	"./store/plugins/asyncOps": [
		"6e7d",
		9,
		"store-plugins-asyncOps"
	],
	"./store/plugins/asyncOps.js": [
		"6e7d",
		9,
		"store-plugins-asyncOps"
	],
	"./store/plugins/cookies": [
		"596e",
		9,
		"store-plugins-cookies"
	],
	"./store/plugins/cookies.js": [
		"596e",
		9,
		"store-plugins-cookies"
	],
	"./store/store": [
		"932a",
		9,
		"chunk-3f011d14",
		"store-store"
	],
	"./store/store.js": [
		"932a",
		9,
		"chunk-3f011d14",
		"store-store"
	],
	"./unregisterServiceWorker": [
		"9c54",
		7
	],
	"./unregisterServiceWorker.js": [
		"9c54",
		7
	],
	"./utilities": [
		"cb20",
		9
	],
	"./utilities.js": [
		"cb20",
		9
	],
	"./utilities/delayAsync": [
		"b6c4",
		9,
		"utilities-delayAsync"
	],
	"./utilities/delayAsync.js": [
		"b6c4",
		9,
		"utilities-delayAsync"
	],
	"./utilities/parallelDynamicImport": [
		"b8bf",
		9
	],
	"./utilities/parallelDynamicImport.js": [
		"b8bf",
		9
	],
	"./utilities/throttleAsyncFunction": [
		"3c1f",
		9
	],
	"./utilities/throttleAsyncFunction.js": [
		"3c1f",
		9
	],
	"./views/About": [
		"3946",
		9,
		"views-About"
	],
	"./views/About.vue": [
		"3946",
		9,
		"views-About"
	],
	"./views/Chat": [
		"f777",
		9,
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"views-Chat"
	],
	"./views/Chat.vue": [
		"f777",
		9,
		"components-base-frameworks-we-form-BaseForm~extensions-composition-layout~extensions-composition-use~d22272e3",
		"views-Chat"
	],
	"./views/Home": [
		"76bf",
		9,
		"views-Home"
	],
	"./views/Home.vue": [
		"76bf",
		9,
		"views-Home"
	],
	"./views/Login": [
		"8457",
		9,
		"views-Login"
	],
	"./views/Login.vue": [
		"8457",
		9,
		"views-Login"
	],
	"./views/PageNotFound": [
		"027f",
		9,
		"views-PageNotFound"
	],
	"./views/PageNotFound.vue": [
		"027f",
		9,
		"views-PageNotFound"
	],
	"./views/PlaceholderComponent": [
		"50a1",
		9,
		"views-PlaceholderComponent"
	],
	"./views/PlaceholderComponent.vue": [
		"50a1",
		9,
		"views-PlaceholderComponent"
	],
	"./views/Register": [
		"02515",
		9,
		"views-Register"
	],
	"./views/Register.vue": [
		"02515",
		9,
		"views-Register"
	],
	"./views/RouterView": [
		"b88b",
		9,
		"views-RouterView"
	],
	"./views/RouterView.vue": [
		"b88b",
		9,
		"views-RouterView"
	],
	"./views/Test": [
		"b0e6",
		9,
		"views-Test"
	],
	"./views/Test.vue": [
		"b0e6",
		9,
		"views-Test"
	],
	"./views/Test1": [
		"a870",
		9,
		"views-Test1"
	],
	"./views/Test1.vue": [
		"a870",
		9,
		"views-Test1"
	],
	"./views/UserProfile": [
		"53d3",
		9,
		"views-UserProfile"
	],
	"./views/UserProfile.vue": [
		"53d3",
		9,
		"views-UserProfile"
	],
	"./views/admin/Dashboard": [
		"8f20",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-Dashboard"
	],
	"./views/admin/Dashboard.vue": [
		"8f20",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-Dashboard"
	],
	"./views/admin/Language": [
		"a7ea",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-Language"
	],
	"./views/admin/Language.vue": [
		"a7ea",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-Language"
	],
	"./views/admin/acl/dashboard": [
		"60c3",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"components-crud-List",
		"views-admin-acl-dashboard"
	],
	"./views/admin/acl/dashboard.vue": [
		"60c3",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"components-crud-List",
		"views-admin-acl-dashboard"
	],
	"./views/admin/config/Edit": [
		"549e",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-config-Edit"
	],
	"./views/admin/config/Edit.vue": [
		"549e",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-config-Edit"
	],
	"./views/admin/config/List": [
		"ecd3",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"components-crud-List",
		"views-admin-config-List"
	],
	"./views/admin/config/List.vue": [
		"ecd3",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"components-crud-List",
		"views-admin-config-List"
	],
	"./views/admin/entity/Create": [
		"3615",
		9,
		"views-admin-entity-Create"
	],
	"./views/admin/entity/Create.vue": [
		"3615",
		9,
		"views-admin-entity-Create"
	],
	"./views/admin/entity/Edit": [
		"c889",
		9,
		"views-admin-entity-Edit"
	],
	"./views/admin/entity/Edit.vue": [
		"c889",
		9,
		"views-admin-entity-Edit"
	],
	"./views/admin/entity/Entity": [
		"44fa",
		9,
		"views-admin-entity-Entity"
	],
	"./views/admin/entity/Entity.vue": [
		"44fa",
		9,
		"views-admin-entity-Entity"
	],
	"./views/admin/entity/EntityDashboard": [
		"f02c",
		9,
		"views-admin-entity-EntityDashboard"
	],
	"./views/admin/entity/EntityDashboard.vue": [
		"f02c",
		9,
		"views-admin-entity-EntityDashboard"
	],
	"./views/admin/entity/List": [
		"dad1",
		9,
		"components-crud-List",
		"views-admin-entity-List"
	],
	"./views/admin/entity/List.vue": [
		"dad1",
		9,
		"components-crud-List",
		"views-admin-entity-List"
	],
	"./views/admin/user/Create": [
		"0cc5",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-user-Create"
	],
	"./views/admin/user/Create.vue": [
		"0cc5",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-user-Create"
	],
	"./views/admin/user/Edit": [
		"9b7f",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-user-Edit"
	],
	"./views/admin/user/Edit.vue": [
		"9b7f",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-admin-user-Edit"
	],
	"./views/admin/user/List": [
		"c485",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"components-crud-List",
		"views-admin-user-List"
	],
	"./views/admin/user/List.vue": [
		"c485",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"components-crud-List",
		"views-admin-user-List"
	],
	"./views/ecommerce/Checkout": [
		"bdb9",
		9,
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"views-ecommerce-Checkout"
	],
	"./views/ecommerce/Checkout.vue": [
		"bdb9",
		9,
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~ba4b61f3",
		"applications-saffronfiles-components-App~components-Saffron~components-base-frameworks-we-form-BaseF~82376235",
		"views-ecommerce-Checkout"
	],
	"./views/general/PageNotFound": [
		"733b",
		9,
		"views-general-PageNotFound"
	],
	"./views/general/PageNotFound.vue": [
		"733b",
		9,
		"views-general-PageNotFound"
	],
	"./views/general/Unauthorised": [
		"48b3",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-general-Unauthorised"
	],
	"./views/general/Unauthorised.vue": [
		"48b3",
		9,
		"applications-saffronfiles-components-App~components-Saffron~extensions-plugins~extensions-plugins-la~5301a632",
		"views-general-Unauthorised"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "58234";
module.exports = webpackAsyncContext;